webpackJsonp([1],{

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared__ = __webpack_require__(355);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
    shared: __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* default */]
  }
});

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return firedb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fireStore; });
/* unused harmony export connectedRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return storage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_firestore__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_storage__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(632);


// These imports load individual services into the firebase namespace.





var app = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].initializeApp({
  apiKey: 'AIzaSyBbMV7q7iiKli5SDvpRSmLe6Ys7AAYyxnY',
  authDomain: 'engineer-ae17e.firebaseapp.com',
  databaseURL: 'https://engineer-ae17e.firebaseio.com',
  projectId: 'engineer-ae17e',
  storageBucket: 'engineer-ae17e.appspot.com',
  messagingSenderId: '93857944365'
});
app.firestore().enablePersistence();

var firedb = app.database();
var fireStore = app.firestore();
var connectedRef = app.database().ref('.info/connected');
var storage = app.storage();
var auth = app.auth();

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dbPromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idb__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_idb__);


function dbPromise() {
  var dbPromise = __WEBPACK_IMPORTED_MODULE_0_idb___default.a.open('engineer-db', 5, function (upgradeDb) {
    switch (upgradeDb.oldVersion) {
      case 0:
        upgradeDb.createObjectStore('outbox', {
          autoIncrement: true
        });
        upgradeDb.createObjectStore('currentJob');
        upgradeDb.createObjectStore('imageStore');
        upgradeDb.createObjectStore('templates');
      // falls through
      case 1:
        upgradeDb.createObjectStore('jobStore');
      // falls through
      case 2:
        upgradeDb.createObjectStore('inProgressJobs', {
          autoIncrement: true
        });
      // falls through
      case 3:
        upgradeDb.createObjectStore('oldTemplates');
      // falls through
      case 4:
        upgradeDb.createObjectStore('fileDirLocation');
    }
  });

  return dbPromise;
}

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(627)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(664),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-162ad93c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clipboard2__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_UploadJobs_vue__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_UploadJobs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_UploadJobs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Shared_Alert_vue__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Shared_Alert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Shared_Alert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_UpdateDialog_vue__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_UpdateDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Shared_UpdateDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Shared_DisclaimerDialog_vue__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Shared_DisclaimerDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Shared_DisclaimerDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Testing_vue__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Testing_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Testing_vue__);










__webpack_require__(626);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    primary: '#4BBBBD',
    secondary: '#091C48',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Upload-Jobs', __WEBPACK_IMPORTED_MODULE_9__components_UploadJobs_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-alert', __WEBPACK_IMPORTED_MODULE_10__components_Shared_Alert_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('update-dialog', __WEBPACK_IMPORTED_MODULE_11__components_Shared_UpdateDialog_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('disclaimer-dialog', __WEBPACK_IMPORTED_MODULE_12__components_Shared_DisclaimerDialog_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('testing', __WEBPACK_IMPORTED_MODULE_13__components_Testing_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_6__App___default.a);
  },
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* store */],
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* auth */].onAuthStateChanged(function (user) {
      if (user) {
        _this.$store.dispatch('autoSignIn', user);
        _this.$store.dispatch('fetchUserData');
        _this.$store.dispatch('setCustomers');
        _this.$store.dispatch('setVehicles');
      }
    });
  }
});

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(105);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user) {
    next();
  } else {
    next('/signin');
  }
});

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dbPromise__ = __webpack_require__(28);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dbPromise__["a" /* default */])().then(function (db) {
    var tx = db.transaction('currentJob');
    var currentStore = tx.objectStore('currentJob');
    return currentStore.getAll();
  }).then(function (val) {
    if (val.length > 0) {
      next();
    } else {
      next('/');
    }
  });
});

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(105);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user) {
    next();
  } else {
    next('/');
  }
});

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CreateJob__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CreateJob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CreateJob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_User_SignIn__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_User_SignIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_User_SignIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_User_ResetPassword__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_User_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_User_ResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Settings__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CurrentJob__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CurrentJob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_CurrentJob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_JobList__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_JobList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_JobList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CustomerList__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CustomerList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_CustomerList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Outbox__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Outbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Outbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Testing__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Testing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Testing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_BulkSMS__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_BulkSMS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_BulkSMS__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CurrentJobGuard__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AuthGuard__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__NotAuthGuard__ = __webpack_require__(353);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/SignIn',
    name: 'SignIn',
    component: __WEBPACK_IMPORTED_MODULE_4__components_User_SignIn___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_15__NotAuthGuard__["a" /* default */]
  }, {
    path: '/ResetPassword/:initialEmail',
    name: 'ResetPassword',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_5__components_User_ResetPassword___default.a
  }, {
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_14__AuthGuard__["a" /* default */]
  }, {
    path: '/createJob',
    name: 'CreateJob',
    component: __WEBPACK_IMPORTED_MODULE_3__components_CreateJob___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_14__AuthGuard__["a" /* default */]
  }, {
    path: '/settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Settings___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_14__AuthGuard__["a" /* default */]
  }, {
    path: '/currentJob',
    name: __WEBPACK_IMPORTED_MODULE_7__components_CurrentJob___default.a,
    component: __WEBPACK_IMPORTED_MODULE_7__components_CurrentJob___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_13__CurrentJobGuard__["a" /* default */]
  }, {
    path: '/jobList',
    name: 'JobList',
    component: __WEBPACK_IMPORTED_MODULE_8__components_JobList___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_14__AuthGuard__["a" /* default */]
  }, {
    path: '/outbox',
    name: 'Outbox',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Outbox___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_14__AuthGuard__["a" /* default */]
  }, {
    path: '/customerList',
    name: 'CustomerList',
    component: __WEBPACK_IMPORTED_MODULE_9__components_CustomerList___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_14__AuthGuard__["a" /* default */]
  }, {
    path: '/Testing',
    name: 'Testing',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Testing___default.a
  }, {
    path: '/BulkSMS',
    name: 'BulkSMS',
    component: __WEBPACK_IMPORTED_MODULE_12__components_BulkSMS___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_14__AuthGuard__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(12);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loading: false,
    error: null,
    customers: [],
    vehicles: []
  },
  mutations: {
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    },
    setCustomers: function setCustomers(state, payload) {
      state.customers = payload;
    },
    setVehicles: function setVehicles(state, payload) {
      state.vehicles = payload;
    },
    addVehicle: function addVehicle(state, payload) {
      state.vehicles.push(payload);
    }
  },
  actions: {
    clearError: function clearError(_ref) {
      var commit = _ref.commit;

      commit('clearError');
    },
    setCustomers: function setCustomers(_ref2) {
      var commit = _ref2.commit;

      var customerArr = [];
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* fireStore */].collection('Customers').get().then(function (snap) {
        snap.forEach(function (doc) {
          var data = doc.data();
          var obj = {
            name: data.customerName,
            shortName: data.shortName,
            id: doc.id
          };
          customerArr.push(obj);
        });
        commit('setCustomers', customerArr);
      });
    },
    setVehicles: function setVehicles(_ref3) {
      var commit = _ref3.commit;

      var vehicleArr = [];
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* fireStore */].collection('Vehicles').get().then(function (snap) {
        snap.forEach(function (doc) {
          var data = doc.data();
          var obj = {
            Customer: data.Customer,
            Make: data.Make,
            Model: data.Model,
            VehicleReg: data.VehicleReg,
            Year: data.Year,
            id: doc.id,
            friendlyId: data.friendlyId
          };
          vehicleArr.push(obj);
        });
        commit('setVehicles', vehicleArr);
      });
    },
    addVehicle: function addVehicle(_ref4, payload) {
      var commit = _ref4.commit;

      commit('addVehicle', payload);
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    },
    customers: function customers(state) {
      return state.customers;
    },
    vehicles: function vehicles(state) {
      return state.vehicles;
    }
  }
});

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(12);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    signUserIn: function signUserIn(_ref, payload) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          email: user.email,
          name: user.displayName,
          company: '',
          fbKeys: {}
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    autoSignIn: function autoSignIn(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setUser', {
        id: payload.uid,
        email: payload.email,
        name: payload.displayName,
        company: payload.company,
        unassigned: payload.unassigned,
        canSMS: payload.canSMS
      });
    },
    fetchUserData: function fetchUserData(_ref3) {
      var commit = _ref3.commit,
          getters = _ref3.getters;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* fireStore */].collection('Users').doc(getters.user.id).get().then(function (doc) {
        var company = doc.data().Company;
        var customers = doc.data().Customers;
        var name = doc.data().Name;
        var email = doc.data().Email;
        var unassigned = doc.data().unassigned !== undefined ? doc.data().unassigned : true;
        var canSMS = doc.data().canSMS !== undefined ? doc.data().canSMS : false;
        var updateUser = {
          id: getters.user.id,
          email: email,
          name: name,
          company: company,
          customers: customers,
          unassigned: unassigned,
          canSMS: canSMS
        };
        commit('setLoading', false);
        commit('setUser', updateUser);
      }).catch(function (error) {
        commit('setLoading', false);
        console.log(error);
      });
    },
    logout: function logout(_ref4) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].signOut();
      commit('setUser', null);
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    }
  }
});

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dbPromise__ = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      drawer: false,
      fixed: false,
      title: 'nexus',
      newVersion: false,
      templates: [],
      oldTemplates: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Versions').doc('App').get().then(function (doc) {
      if (doc.data().Version !== 3.18) {
        _this.newVersion = true;
      }
    });
    sessionStorage.removeItem('isSending');
    this.retrieveTemplates();
    this.retrieveOldTemplates();
    this.refreshTemplates();
    this.refreshOldTemplates();
  },

  computed: {
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    onLogout: function onLogout() {
      this.$store.dispatch('logout');
      this.$router.push('/SignIn');
    },
    update: function update() {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(registrations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var registration = _step.value;

            registration.unregister();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }).then(function (boolean) {
        caches.delete('v1-engineer-cache').then(function (boolean) {
          window.location.reload(true);
        });
      });
    },
    retrieveTemplates: function retrieveTemplates() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('templates');
        var templateStore = tx.objectStore('templates');
        return templateStore.getAll();
      }).then(function (val) {
        console.log(val);
        _this2.templates = [];
        if (val.length > 0) {
          val.forEach(function (template) {
            _this2.templates.push(template);
          });
        }
      });
    },
    retrieveOldTemplates: function retrieveOldTemplates() {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('oldTemplates');
        var templateStore = tx.objectStore('oldTemplates');
        return templateStore.getAll();
      }).then(function (val) {
        console.log(val);
        _this3.oldTemplates = [];
        if (val.length > 0) {
          val.forEach(function (template) {
            _this3.oldTemplates.push(template);
          });
        }
      });
    },
    refreshTemplates: function refreshTemplates() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('deviceType').get().then(function (snap) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('templates', 'readwrite');
          var currentStore = tx.objectStore('templates');
          currentStore.clear();
          return tx.complete;
        }).then(function () {
          snap.forEach(function (doc) {
            var data = doc.data();
            data.items.forEach(function (item) {
              item.image = '';
              item.note = '';
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
              var tx = db.transaction('templates', 'readwrite');
              var templateStore = tx.objectStore('templates');
              templateStore.put(data, doc.id);
              return tx.complete;
            }).then(function () {
              _this4.templates.push(data);
            });
          });
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    refreshOldTemplates: function refreshOldTemplates() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Templates').get().then(function (snap) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('oldTemplates', 'readwrite');
          var currentStore = tx.objectStore('oldTemplates');
          currentStore.clear();
          return tx.complete;
        }).then(function () {
          snap.forEach(function (doc) {
            var data = doc.data();
            data.items.forEach(function (item) {
              item.image = '';
              item.note = '';
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
              var tx = db.transaction('oldTemplates', 'readwrite');
              var templateStore = tx.objectStore('oldTemplates');
              templateStore.put(data, doc.id).length > 10;
              return tx.complete;
            }).then(function () {
              _this5.oldTemplates.push(data);
            });
          });
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      active: null,
      excelInput: '',
      dataLooksGood: false,
      includeHeaders: false,
      processedData: [],
      dataProcessed: false,
      processing: false,
      expandResults: false,
      simDetailsSent: false,
      lookupDialog: false,
      lookupType: 'ESN',
      lookupSource: 'Calamp-CTC',
      lookupNumber: '',
      lookupNoResults: false,
      lookingUp: false,
      availableColumns: [{ text: 'simId', value: 'simId' }, { text: 'customAttribute1', value: 'customAttribute1' }, { text: 'customAttribute2', value: 'customAttribute2' }, { text: 'customAttribute3', value: 'customAttribute3' }, { text: 'customAttribute4', value: 'customAttribute4' }, { text: 'customAttribute5', value: 'customAttribute5' }, { text: 'state', value: 'state' }, { text: 'customerServiceProfile', value: 'customerServiceProfile' }],
      columnMap: [{ text: 'simId', value: 'simId' }, { text: 'customAttribute1', value: 'customAttribute1' }, { text: 'customAttribute2', value: 'customAttribute2' }, { text: 'customAttribute3', value: 'customAttribute3' }, { text: 'customAttribute4', value: 'customAttribute4' }, { text: 'customAttribute5', value: 'customAttribute5' }, { text: 'state', value: 'state' }, { text: 'customerServiceProfile', value: 'customerServiceProfile' }],
      messageTemplates: [],
      messageType: 0,
      inputICCID: '',
      ICCIDarray: sessionStorage.getItem('ICCIDS') ? JSON.parse(sessionStorage.getItem('ICCIDS')) : [],
      bulk: false,
      message: '',
      sending: false,
      messageSent: false,
      snap: null,
      authToken: null,
      headers: [{ text: 'ICCID', value: 'ICCID' }, { text: 'Message', value: 'message' }, { text: 'State', value: 'state' }],
      messageStates: [],
      types: [{ type: 0, name: 'Payload SMS' }, { type: 1, name: 'Transactional SMS' }]
    };
  },
  mounted: function mounted() {
    // this.bulk = this.ICCIDarray.length < 1
    sessionStorage.removeItem('ICCIDS');
    this.getSMSTemplates();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.snap !== null) {
      this.snap();
    }
  },

  watch: {
    lookupDialog: function lookupDialog(val) {
      var _this = this;

      if (val) {
        this.lookingUp = true;
        fetch('https://cwelite.aquariusit.com/calampMiddleManGetToken.php', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          return response.json();
        }).then(function (token) {
          _this.authToken = token.authToken;
          _this.lookingUp = false;
        }).catch(function (error) {
          return alert(error);
        });
      }
    }
  },
  computed: {
    filteredMessageStates: function filteredMessageStates() {
      var filteredMessageStates = [];
      for (var i = 0; i < this.messageStates.length; i++) {
        var element = this.messageStates[i];
        element.message = atob(element.message);
        if (element.response === undefined) {
          element.state = 0;
        } else {
          for (var value in element.response) {
            if (element.response.id) {
              element.state = -1;
            } else if (element.response[value].return.returnCode.majorReturnCode === '000') {
              element.state = 1;
            } else {
              element.state = -1;
            }
          }
        }
        element.packet = element.packet === undefined ? '' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(element.packet, null, ' ');
        element.response = element.response === undefined ? '' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(element.response, null, ' ');
        filteredMessageStates.push(element);
      }
      return filteredMessageStates;
    }
  },
  methods: {
    getSMSTemplates: function getSMSTemplates() {
      var _this2 = this;

      this.messageTemplates = [];
      __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* fireStore */].collection('smsTemplates').where('engineer', '==', true).orderBy('text').get().then(function (snap) {
        snap.forEach(function (doc) {
          _this2.messageTemplates.push(doc.data());
        });
      });
    },
    lookupICCID: function lookupICCID() {
      var _this3 = this;

      this.lookingUp = true;
      if (this.lookupSource === 'Nexus') {
        var lookupType = this.lookupType === 'ESN' ? 'uid' : 'IMEI';
        __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* fireStore */].collection('Devices').where(lookupType, '==', this.lookupNumber).get().then(function (snap) {
          if (snap.docs.length) {
            snap.forEach(function (doc) {
              _this3.ICCIDarray.push(doc.data().SIM);
            });
            _this3.lookupDialog = false;
          } else {
            _this3.lookupNoResults = true;
          }
          _this3.lookingUp = false;
        });
      } else {
        var requestOptions = {
          method: 'POST',
          redirect: 'follow',
          mode: 'cors',
          body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            'params': '{"search": { "queryString": "' + this.lookupNumber + '"}}',
            'endpoint': 'device-services/devices/smartsearch?include=groups&withIdReport=true&withCredentials=true&withLocation=true&expand=deviceConfiguration&v=2.1&pg=1&pgsize=10&sort=+name',
            'authToken': this.authToken
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        };

        fetch('https://cwelite.aquariusit.com/calampMiddleManPost.php', requestOptions).then(function (response) {
          return response.json();
        }).then(function (result) {
          if (result.response.results.length) {
            _this3.ICCIDarray.push(result.response.results[0].device.iccid);
            _this3.lookupDialog = false;
          } else {
            _this3.lookupNoResults = true;
          }
          _this3.lookingUp = false;
        });
      }
    },
    reset: function reset() {
      this.snap();
      this.sending = false;
      this.messageSent = false;
    },
    processRawData: function processRawData() {
      var _this4 = this;

      this.processing = true;
      this.processedData = [];
      var columnMap = this.columnMap;
      var rows = [];
      rows = this.excelInput.split('\n');
      if (this.includeHeaders) {
        rows.splice(0, 1);
      }
      rows.forEach(function (row) {
        if (row === '') {
          return;
        }
        var cols = row.split('\t');
        var obj = {};
        for (var i = 0; i < cols.length; i++) {
          if (i === 0) {
            columnMap.splice(cols.length);
          }
          if (cols[i] && cols[i].length > 0 && columnMap[i]) {
            obj[columnMap[i].value] = cols[i];
          }
        }
        _this4.processedData.push(obj);
      });
      this.dataProcessed = true;
      this.processing = false;
    },
    updateICCID: function updateICCID() {
      var concatICCIDs = this.inputICCID.replace(/\s/g, '').replace(/;/g, '').replace(/,/g, '');
      this.ICCIDarray = this.ICCIDarray.concat(concatICCIDs.match(/(.{1,20})/g)).filter(function (v, i, a) {
        return a.indexOf(v) === i && !isNaN(v);
      });
      this.inputICCID = '';
      this.bulk = false;
    },
    startSnapshot: function startSnapshot(id) {
      var _this5 = this;

      this.snap = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* fireStore */].collection('SIMmessages').doc(id).onSnapshot(function (snap) {
        var data = snap.data().messages;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var message = _step.value;

            message.id = message.ICCID + message.message;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this5.messageStates = data;
      });
    },
    sendMessages: function sendMessages() {
      var _this6 = this;

      this.sending = true;
      var messageData = [];
      for (var i = 0; i < this.ICCIDarray.length; i++) {
        if (this.ICCIDarray[i].length !== 20) {
          alert('Cannot send messages! Invalid ID: ' + this.ICCIDarray[i]);
          this.sending = false;
          return;
        }
        for (var m in this.message) {
          messageData.push({
            messageType: this.messageType,
            ICCID: this.ICCIDarray[i],
            message: btoa(this.message[m])
          });
        }
      }
      __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* fireStore */].collection('SIMmessages').add({
        messages: messageData,
        time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD HH:mm'),
        user: this.$store.getters.user.name
      }).then(function (val) {
        _this6.startSnapshot(val.id);
        _this6.messageSent = true;
      }).catch(function (error) {
        alert('Unexpected Error Occured');
        console.log(error);
      });
    },
    sendSimDetails: function sendSimDetails() {
      var _this7 = this;

      this.sending = true;
      var messageData = [];
      for (var i = 0; i < this.processedData.length; i++) {
        var msgObj = {};
        msgObj.packet = this.processedData[i];
        msgObj.packet.simIdType = 'ICCID';
        msgObj.messageType = 2;
        msgObj.ICCID = msgObj.packet.simId;
        msgObj.message = btoa('sim update');
        messageData.push(msgObj);
      }
      __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* fireStore */].collection('SIMmessages').add({
        messages: messageData,
        time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD HH:mm'),
        user: this.$store.getters.user.name
      }).then(function (val) {
        _this7.startSnapshot(val.id);
        _this7.messageSent = true;
      }).catch(function (error) {
        alert('Unexpected Error Occured');
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dbPromise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currentAlert: false,
      templates: [],
      customerFilter: '',
      currentJob: {
        Customer: '',
        Vehicle: '',
        Date: '',
        imei: ''
      },
      valid: false,
      customerRules: [function (v) {
        return !!v && v.length > 0 || 'Customer is required';
      }],
      vehicleRules: [function (v) {
        return !!v || 'Vehicle Registration is required';
      }],
      creating: false,
      user: this.$store.getters.user,
      disclaimerDialog: false,
      customerLoading: false,
      duplicateDialog: false,
      activeJob: null,
      confirmCreate: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.currentJob.Date = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
      var tx = db.transaction('currentJob');
      var currentStore = tx.objectStore('currentJob');
      return currentStore.getAll();
    }).then(function (val) {
      if (val.length > 0) {
        _this.currentJob = val[0];
        _this.currentAlert = true;
      } else {
        _this.currentAlert = false;
        _this.disclaimerDialog = true;
      }
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
      var tx = db.transaction('templates');
      var templateStore = tx.objectStore('templates');
      return templateStore.getAll();
    }).then(function (val) {
      console.log(val);
      _this.templates = [];
      if (val.length > 0) {
        val.forEach(function (template) {
          _this.templates.push(template);
        });
      }
      _this.templates.sort(function (a, b) {
        return a.Index - b.Index;
      });
    });
  },

  watch: {
    'currentJob.Vehicle': function currentJobVehicle(val) {
      var _this2 = this;

      if (val) {
        val = val.toUpperCase().replace(/\s/g, '');
        this.customerLoading = true;
        setTimeout(function () {
          _this2.customerLoading = false;
        }, 2000);
        __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Vehicles').where('VehicleReg', '==', val).get().then(function (snap) {
          snap.forEach(function (doc) {
            console.log(doc.data().Customer);
            _this2.currentJob.Customer = doc.data().Customer;
          });
        });
      }
    }
  },
  methods: {
    createFromOGJob: function createFromOGJob() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Jobs').doc(this.activeJob.number).update({ jobStarted: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('x'), Allocated: this.user.id });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('currentJob', 'readwrite');
        var currentStore = tx.objectStore('currentJob');

        currentStore.put({
          Customer: _this3.activeJob.Customer,
          number: _this3.activeJob.number,
          reg: _this3.activeJob.vehReg,
          JobNo: _this3.activeJob.JobNo,
          imei: _this3.activeJob.imei,
          vehicle: _this3.activeJob.Vehicle,
          newMethod: _this3.activeJob.newMethod,
          jobLookupIds: _this3.activeJob.jobLookupIds,
          startTime: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('x'),
          notes: _this3.activeJob.notes || '',
          chargeable: false,
          CreatedDate: Date.now()
        }, 0);
        return tx.complete;
      }).then(function () {
        var templates = [];
        _this3.templates.forEach(function (template) {
          console.log(template.id);
          console.log(_this3.activeJob.templates);
          if (_this3.activeJob.templates.indexOf(template.id) !== -1) {
            templates.push(template);
          }
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('currentJob', 'readwrite');
          var currentStore = tx.objectStore('currentJob');
          currentStore.put(templates, 1);
          return tx.complete;
        }).then(function () {
          _this3.$router.push('/CurrentJob');
        });
      });
    },
    confirmAndCreate: function confirmAndCreate() {
      this.confirmCreate = true;
      this.createJob();
    },
    createJob: function createJob() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var vehicleExists, jobData, promise, docRef, customerIndex, shortName, projectIds, projectId, dataToSend, response, promise2;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this4.$refs.form.validate()) {
                  _context.next = 33;
                  break;
                }

                _this4.creating = true;
                vehicleExists = _this4.vehicles.find(function (vehicle) {
                  return _this4.currentJob.Vehicle === vehicle.VehicleReg || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this4.currentJob.Vehicle) === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(vehicle) || _this4.currentJob.vehicle === vehicle.id;
                });

                if (!(!_this4.confirmCreate && vehicleExists)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Jobs').where('Vehicle', '==', vehicleExists.id).where('Status', '<=', 0).get();

              case 6:
                jobData = _context.sent;

                _this4.activeJob = null;
                if (!jobData.empty) {
                  _this4.activeJob = jobData.docs[0].data();
                  _this4.activeJob.number = jobData.docs[0].id;
                }

                if (!_this4.activeJob) {
                  _context.next = 12;
                  break;
                }

                _this4.duplicateDialog = true;
                return _context.abrupt('return');

              case 12:
                promise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  if (!vehicleExists) {
                    __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Vehicles').add({ VehicleReg: _this4.currentJob.Vehicle, Customer: _this4.currentJob.Customer }).then(function (docRef) {
                      _this4.$store.dispatch('addVehicle', {
                        Customer: _this4.currentJob.Customer,
                        VehicleReg: _this4.currentJob.Vehicle.toUpperCase().replace(/\s/g, ''),
                        id: docRef.id
                      });
                      _this4.currentJob.reg = _this4.currentJob.Vehicle;
                      _this4.currentJob.Vehicle = docRef.id;
                      resolve();
                    });
                  } else {
                    _this4.currentJob.reg = vehicleExists.VehicleReg;
                    _this4.currentJob.Vehicle = vehicleExists.id;
                    resolve();
                  }
                });
                _context.next = 15;
                return __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Projects').where('Customer', '==', _this4.currentJob.Customer).get();

              case 15:
                docRef = _context.sent;
                customerIndex = _this4.customers.findIndex(function (customerListObj) {
                  return customerListObj.id === _this4.currentJob.Customer;
                });
                shortName = _this4.customers[customerIndex]['shortName'];
                projectIds = [];
                projectId = '';

                docRef.forEach(function (doc) {
                  var projId = doc.data().projectId;
                  if (projId) {
                    projId = projId.replace(/\D/g, '');
                    projectIds.push(projId);
                  }
                });
                projectIds = projectIds.sort();
                projectIds = projectIds.reverse();
                if (projectIds.length === 0) {
                  projectIds.push(0);
                }
                projectId = projectIds[0];
                projectId = 'EC-' + shortName + _this4.zeroFill(parseInt(projectId) + 1, 4);
                dataToSend = { jobType: 'Service Call', CreatedDate: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD'), supplierPO: null, supplierCost: null, customerPO: null, customerCost: null, Customer: _this4.currentJob.Customer, projectId: projectId, Status: 'Install In Progress', notes: 'Created by engineer on app.' };
                _context.next = 29;
                return __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Projects').add(dataToSend);

              case 29:
                response = _context.sent;


                console.log(response);

                promise2 = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var jobNumbers = [0];
                  var customerIndex = _this4.customers.findIndex(function (customer) {
                    return _this4.currentJob.Customer === customer.id;
                  });
                  var shortName = _this4.customers[customerIndex]['shortName'];
                  __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Jobs').where('Customer', '==', _this4.currentJob.Customer).get().then(function (snap) {
                    snap.forEach(function (doc) {
                      var JobNo = doc.data().JobNo;
                      if (JobNo && JobNo.indexOf(shortName) > -1) {
                        // This check is needed in case the short name has been changed. We only want to increment on job numbers with the new short name.
                        JobNo = JobNo.replace(/\D/g, '');
                        jobNumbers.push(JobNo);
                      }
                    });
                    jobNumbers.sort(function (a, b) {
                      return b - a;
                    });
                    console.log(jobNumbers);
                    _this4.currentJob.JobNo = shortName + _this4.zeroFill(parseInt(jobNumbers[0]) + 1, 4);
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                });

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([promise, promise2]).then(function (values) {
                  console.log(_this4.currentJob);
                  _this4.currentJob.unscheduled = 0;
                  if (!_this4.currentJob.Date) {
                    _this4.currentJob.Date = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD');
                  }
                  if (_this4.currentJob.imei === undefined || _this4.currentJob.imei === null) {
                    _this4.currentJob.imei = '';
                  }
                  var templates = ['preCheck'];
                  _this4.templates.forEach(function (template) {
                    if (template.required && template.id !== 'preCheck') {
                      templates.push(template.id);
                    }
                  });
                  if (_this4.currentJob.templates) {
                    templates = _this4.currentJob.templates;
                  }
                  var jobject = {
                    jobLookupIds: _this4.currentJob.jobLookupIds || [],
                    JobNo: _this4.currentJob.JobNo,
                    Customer: _this4.currentJob.Customer,
                    Vehicle: _this4.currentJob.Vehicle,
                    reg: _this4.currentJob.reg,
                    imei: _this4.currentJob.imei,
                    Date: _this4.currentJob.Date,
                    templates: templates,
                    unscheduled: _this4.currentJob.unscheduled,
                    Project: projectId,
                    Status: -1,
                    chargeable: false,
                    Allocated: _this4.user.id,
                    Supplier: _this4.user.company ? _this4.user.company : '',
                    startTime: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('x'),
                    CreatedDate: Date.now()
                  };
                  console.log(jobject);
                  __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Jobs').add(jobject).then(function (docRef) {
                    jobject.number = docRef.id;
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
                      var tx = db.transaction('currentJob', 'readwrite');
                      var currentStore = tx.objectStore('currentJob');
                      currentStore.put(jobject, 0);
                      return tx.complete;
                    }).then(function () {
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
                        var tx = db.transaction('currentJob', 'readwrite');
                        var currentStore = tx.objectStore('currentJob');
                        var templates = [];
                        _this4.templates.forEach(function (element) {
                          if (element.required) {
                            templates.push(element);
                          }
                        });
                        currentStore.put(templates, 1);
                        return tx.complete;
                      }).then(function () {
                        _this4.creating = false;
                        _this4.$router.push('/CurrentJob');
                      });
                    });
                  });
                }).catch(function (error) {
                  console.log(error);
                  _this4.creating = false;
                });

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    discardCurrentJob: function discardCurrentJob() {
      var _this5 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('currentJob', 'readwrite');
        var currentStore = tx.objectStore('currentJob');

        currentStore.clear();
        return tx.complete;
      }).then(function () {
        _this5.currentJob = {
          Customer: '',
          Vehicle: '',
          Date: '',
          imei: ''
        };
        _this5.currentAlert = false;
      });
    },
    zeroFill: function zeroFill(number, width) {
      width -= number.toString().length;
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
      }
      return number;
    }
  },
  computed: {
    customers: function customers() {
      var _this6 = this;

      if ((!this.customerFilter || this.customerFilter.length < 3) && !this.currentJob.Customer) {
        return [];
      }

      return this.$store.getters.customers.filter(function (a) {
        if (!_this6.user.customers || _this6.user.customers.length <= 0) {
          return true;
        } else {
          return _this6.user.customers.indexOf(a.id) !== -1;
        }
      }).sort(function (a, b) {
        var aName = a.name.toLowerCase();
        var bName = b.name.toLowerCase();
        return aName < bName ? -1 : aName > bName ? 1 : 0;
      });
    },
    vehicles: function vehicles() {
      var _this7 = this;

      var vehicles = this.$store.getters.vehicles;
      var customerVehicles = [];
      vehicles.forEach(function (vehicle) {
        if (vehicle.Customer === _this7.currentJob.Customer) {
          customerVehicles.push(vehicle);
        }
        if (!vehicle.VehicleReg) {
          vehicle.VehicleReg = vehicle.friendlyId ? vehicle.friendlyId : vehicle.id;
        }
      });
      return customerVehicles.sort(function (a, b) {
        var aVehReg = a.VehicleReg;
        var bVehReg = b.VehicleReg;
        if (!aVehReg) {
          return 0;
        }
        if (!bVehReg) {
          return 1;
        }
        return aVehReg.toLowerCase() < bVehReg.toLowerCase() ? -1 : aVehReg.toLowerCase() > bVehReg.toLowerCase() ? 1 : 0;
      });
    }
  }
});

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dbPromise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jszip__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__firebase__ = __webpack_require__(12);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      templates: [{
        items: {
          1: {
            optional: false,
            image: '',
            note: '',
            photo: false
          }
        }
      }],
      fullImage: false,
      fullImageSrc: '',
      fullImageTemplate: null,
      fullImageChild: null,
      testingDialog: false,
      currentItem: '',
      currentNote: '',
      customerName: '',
      enterNote: false,
      imageProcessing: false,
      currentJob: {
        Customer: '',
        Vehicle: '',
        notes: '',
        chargeable: false
      },
      imageObj: {},
      testID: '',
      testType: 'IMEI',
      imageDirectoryHandle: null,
      quickSend: false,
      rdlTestDialog: false,
      dlTestDialog: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
      var tx = db.transaction('currentJob');
      var currentStore = tx.objectStore('currentJob');
      return currentStore.getAll();
    }).then(function (val) {
      if (val.length > 0) {
        _this.currentJob = val[0];
        _this.templates = val[1];
        console.log(_this.templates);
        if (_this.templates.findIndex(function (template) {
          return ['Calamp Trailer', 'Calamp Trailer No EBS Cable', 'Trailer Smart Novacom', 'Temperature', 'Trailer Service Call'].indexOf(template.name) !== -1;
        }) > -1) {
          var index = _this.templates.findIndex(function (template) {
            return template.name === 'Vehicle Pre-Install Check';
          });
          if (index > -1) {
            _this.templates.splice(index, 1);
          }
          var pIndex = _this.templates.findIndex(function (template) {
            return template.name === 'Post Install Check & Testing';
          });
          if (pIndex > -1) {
            _this.templates.splice(pIndex, 1);
          }
        }
        __WEBPACK_IMPORTED_MODULE_9__firebase__["b" /* fireStore */].collection('Customers').doc(_this.currentJob.Customer).get().then(function (doc) {
          _this.customerName = doc.data().customerName;
        });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this.templates), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var template = _step.value;

            var _loop = function _loop(item) {
              if (item.image) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
                  var tx = db.transaction('imageStore');
                  var imageStore = tx.objectStore('imageStore');
                  return imageStore.get(item.image);
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(image) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _this.imageObj[item.image] = image.image;

                          case 1:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }
            };

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(template.items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                _loop(item);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    });

    // dbPromise().then((db) => {
    //   let tx = db.transaction('fileDirLocation')
    //   let fileDirLocation = tx.objectStore('fileDirLocation')
    //   return (fileDirLocation.getAll())
    // }).then((val) => {
    //   if (val.length > 0) {
    //     this.imageDirectoryHandle = val[0]
    //   }
    // })
  },

  computed: {
    readyToSend: function readyToSend() {
      for (var template in this.templates) {
        for (var item in this.templates[template].items) {
          if (this.templates[template].items[item].optional === false && this.templates[template].items[item].image === '' && this.templates[template].items[item].note === '') {
            return true;
          }
        }
      }
      return false;
    },
    vehicles: function vehicles() {
      return this.$store.getters.vehicles;
    },
    currentJobVehicle: function currentJobVehicle() {
      var _this2 = this;

      var index = this.vehicles.findIndex(function (vehicle) {
        return _this2.currentJob.vehicle === vehicle.id;
      });
      if (index > -1) {
        return this.vehicles[index]['VehicleReg'];
      } else {
        return null;
      }
    }
  },
  methods: {
    rdlTest: function rdlTest() {
      setTimeout(function () {
        document.getElementById('rdlFrame').src = document.getElementById('rdlFrame').src;
      }, 200);
      this.rdlTestDialog = true;
    },
    dlTest: function dlTest() {
      setTimeout(function () {
        document.getElementById('dlFrame').src = document.getElementById('dlFrame').src;
      }, 200);
      this.dlTestDialog = true;
    },
    changeImage: function changeImage() {
      this.triggerPick(this.fullImageTemplate, this.fullImageChild, 'photo');
      this.fullImage = false;
    },
    openFullImage: function openFullImage(imageSrc, template, child) {
      this.fullImageSrc = imageSrc;
      this.fullImageTemplate = template;
      this.fullImageChild = child;
      this.fullImage = true;
    },
    createFileStore: function createFileStore() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var dirHandle;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return window.showDirectoryPicker();

              case 2:
                dirHandle = _context2.sent;
                _context2.next = 5;
                return dirHandle.getDirectoryHandle('Engineer Images', {
                  create: true
                });

              case 5:
                _this3.imageDirectoryHandle = _context2.sent;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
                  var tx = db.transaction('fileDirLocation', 'readwrite');
                  var fileDirLocation = tx.objectStore('fileDirLocation');

                  fileDirLocation.put(_this3.imageDirectoryHandle, 1);
                  return tx.complete;
                }).then(function () {
                  console.log('saved');
                });

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    gotoIsniTestPage: function gotoIsniTestPage() {
      window.open('http://c.isni.co');
    },
    saveTest: function saveTest(value) {
      var _this4 = this;

      this.templates[this.currentItem[0]]['items'][this.currentItem[1]]['note'] = value;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('currentJob', 'readwrite');
        var currentStore = tx.objectStore('currentJob');

        currentStore.put(_this4.templates, 1);
        return tx.complete;
      });
    },
    gotoTestPage: function gotoTestPage(template, child) {
      this.currentItem = [template, child];
      if (this.currentJob.jobLookupIds) {
        var testingDetails = this.currentJob.jobLookupIds.find(function (id) {
          return id.IMEI || id.DVR;
        });
        if (testingDetails) {
          this.testType = testingDetails.IMEI ? 'IMEI' : 'DVR';
          this.testID = testingDetails[this.testType];
        } else if (this.currentJob.imei) {
          this.testType = 'IMEI';
          this.testID = this.currentJob.imei;
        }
      }
      this.testingDialog = true;
    },
    saveNote: function saveNote() {
      var _this5 = this;

      this.templates[this.currentItem[0]]['items'][this.currentItem[1]]['note'] = this.currentNote;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('currentJob', 'readwrite');
        var currentStore = tx.objectStore('currentJob');

        currentStore.put(_this5.templates, 1);
        return tx.complete;
      }).then(function () {
        _this5.enterNote = false;
      });
    },
    saveJob: function saveJob() {
      var _this6 = this;

      console.log('save Jonb');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('currentJob', 'readwrite');
        var currentStore = tx.objectStore('currentJob');

        currentStore.put(_this6.currentJob, 0);
        return tx.complete;
      });
    },
    checkListComplete: function checkListComplete(i) {
      for (var item in this.templates[i].items) {
        if (this.templates[i].items[item].optional === false && this.templates[i].items[item].image === '' && this.templates[i].items[item].note === '') {
          return 'mb-1';
        }
      }
      return 'green mb-1';
    },
    listIcon: function listIcon(item) {
      if (!item.test && item.photo === true) {
        return item.image.length > 0 ? 'check' : 'add_a_photo';
      } else {
        return item.note.length > 0 ? 'check' : 'note_add';
      }
    },
    triggerPick: function triggerPick(template, child, type) {
      if (!this.imageProcessing) {
        this.currentItem = [template, child];
        if (type === 'photo') {
          document.getElementById('imagePicker').click();
          this.currentNote = '';
        } else {
          this.enterNote = true;
          this.currentNote = this.templates[this.currentItem[0]]['items'][this.currentItem[1]]['note'];
        }
      }
    },
    saveForLater: function saveForLater() {
      var _this7 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('inProgressJobs', 'readwrite');
        var inProgressStore = tx.objectStore('inProgressJobs');
        var arr = [];
        arr[0] = _this7.currentJob;
        arr[1] = _this7.templates;
        if (_this7.currentJob.inProgressKey) {
          inProgressStore.put(arr, _this7.currentJob.inProgressKey);
        } else {
          inProgressStore.put(arr);
        }
        return tx.complete;
      }).then(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('currentJob', 'readwrite');
          var currentStore = tx.objectStore('currentJob');

          currentStore.clear();
          return tx.complete;
        }).then(function () {
          _this7.$router.push('/JobList');
        });
      });
    },
    completeJob: function completeJob() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_9__firebase__["b" /* fireStore */].collection('Jobs').doc(this.currentJob.number).update({ jobEnded: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('x') });
      this.currentJob.CompletedDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD');
      this.currentJob.endTime = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('x');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('outbox', 'readwrite');
        var outboxStore = tx.objectStore('outbox');
        var completedJob = _this8.currentJob;
        completedJob.template = _this8.templates;
        outboxStore.put(completedJob);
        return tx.complete;
      }).then(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('currentJob', 'readwrite');
          var currentStore = tx.objectStore('currentJob');

          currentStore.clear();
          if (_this8.currentJob.inProgressKey) {
            tx = db.transaction('inProgressJobs', 'readwrite');
            var inProgressStore = tx.objectStore('inProgressJobs');
            inProgressStore.delete(_this8.currentJob.inProgressKey);
          }

          return tx.complete;
        }).then(function () {
          _this8.$router.push('/');
        });
      });
    },
    vehicleRegFromID: function vehicleRegFromID(id) {
      var index = this.vehicles.findIndex(function (vehicle) {
        return vehicle.id === id;
      });
      if (index > -1) {
        return this.vehicles[index]['VehicleReg'];
      } else {
        return '';
      }
    },
    saveImages: function saveImages(e) {
      var _this9 = this;

      this.imageProcessing = true;
      var file = e.target.files[0];
      var filename = Date.now() + '.jpg';
      var reader = new FileReader();
      if (file) {
        reader.readAsArrayBuffer(file);
        reader.onload = function (event) {
          var exif = _this9.getExifData(event.target.result);
          var c = document.getElementById('imageCanvas');
          var ctx = c.getContext('2d');
          var img = new Image();
          if (img.style.imageOrientation !== undefined) {
            exif = 1;
          }
          img.src = URL.createObjectURL(e.target.files[0]);
          img.onload = function () {
            if (exif > 4) {
              c.width = img.height / 2;
              c.height = img.width / 2;
              ctx.scale(0.5, 0.5);
              ctx.clearRect(0, 0, c.width, c.height);
              ctx.translate(img.height / 2, img.width / 2);
              if (exif > 6) {
                ctx.rotate(270 * Math.PI / 180);
              } else {
                ctx.rotate(90 * Math.PI / 180);
              }
              ctx.drawImage(img, -img.width / 2, -img.height / 2);
            } else {
              c.width = img.width / 2;
              c.height = img.height / 2;
              ctx.scale(0.5, 0.5);
              if (exif === 3 || exif === 4) {
                ctx.clearRect(0, 0, c.width, c.height);
                ctx.translate(img.width, img.height);
                ctx.rotate(180 * Math.PI / 180);
              }
              ctx.drawImage(img, 0, 0);
            }
            var cameraQuality = localStorage.getItem('cameraQuality') !== null && localStorage.getItem('cameraQuality') !== undefined ? localStorage.cameraQuality : 30;
            cameraQuality = cameraQuality / 100;
            var base64data = c.toDataURL('image/jpeg', cameraQuality);
            _this9.imageObj[filename] = base64data;

            _this9.$forceUpdate();

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
              var tx = db.transaction('imageStore', 'readwrite');
              var imageStore = tx.objectStore('imageStore');

              imageStore.put({ image: base64data, name: filename, type: file.type }, filename);
              return tx.complete;
            }).then(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
              var image, imageName, imageObj;
              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _this9.snackbar = true;
                      _this9.templates[_this9.currentItem[0]]['items'][_this9.currentItem[1]]['image'] = filename;

                      if (!_this9.quickSend) {
                        _context3.next = 17;
                        break;
                      }

                      image = base64data;
                      imageName = filename;
                      _context3.prev = 5;
                      _context3.next = 8;
                      return _this9.uploadImage(_this9.currentJob, imageName);

                    case 8:
                      imageObj = _context3.sent;

                      _this9.templates[_this9.currentItem[0]]['items'][_this9.currentItem[1]]['image'] = imageObj.ref;
                      _this9.templates[_this9.currentItem[0]]['items'][_this9.currentItem[1]]['imageName'] = imageObj.name;
                      _this9.deleteImageFromDB(image);
                      _context3.next = 17;
                      break;

                    case 14:
                      _context3.prev = 14;
                      _context3.t0 = _context3['catch'](5);

                      console.log(_context3.t0);

                    case 17:
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
                        var tx = db.transaction('currentJob', 'readwrite');
                        var currentStore = tx.objectStore('currentJob');

                        currentStore.put(_this9.templates, 1);
                        return tx.complete;
                      }).then(function () {
                        _this9.snackbarText = 'Image saved locally';
                        document.getElementById('imagePicker').value = '';
                        _this9.imageProcessing = false;
                      });

                    case 18:
                    case 'end':
                      return _context3.stop();
                  }
                }
              }, _callee3, _this9, [[5, 14]]);
            }))).catch(function (e) {
              console.log(e);
              _this9.imageProcessing = false;
            });
          };
        };
      }
    },
    deleteImageFromDB: function deleteImageFromDB(key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('imageStore', 'readwrite');
        var imageStore = tx.objectStore('imageStore');
        imageStore.delete(key);
        return true;
      }).catch(function () {
        return false;
      });
    },
    uploadImage: function uploadImage(job, image) {
      var _this10 = this;

      console.log(image);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('imageStore');
        var imageStore = tx.objectStore('imageStore');
        return imageStore.get(image);
      }).then(function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(image) {
          var bytes, ref, response;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!image) {
                    _context4.next = 7;
                    break;
                  }

                  bytes = image.image;
                  ref = __WEBPACK_IMPORTED_MODULE_9__firebase__["d" /* storage */].ref(job.JobNo + '/' + image.name);
                  _context4.next = 5;
                  return ref.putString(bytes, 'data_url', { cacheControl: 'only-if-cached' });

                case 5:
                  response = _context4.sent;
                  return _context4.abrupt('return', { ref: response, name: image.name });

                case 7:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this10);
        }));

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }()).then(function (snapshotObj) {
        return { ref: snapshotObj.ref.downloadURL, name: snapshotObj.name };
      });
    },
    saveToDisk: function saveToDisk(data) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var hasPermission, handle;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log(_this11.imageDirectoryHandle);
                hasPermission = false;
                // Check if permission was already granted. If so, return true.

                _context5.next = 4;
                return _this11.imageDirectoryHandle.queryPermission({ mode: 'readwrite' });

              case 4:
                _context5.t0 = _context5.sent;

                if (!(_context5.t0 === 'granted')) {
                  _context5.next = 7;
                  break;
                }

                hasPermission = true;

              case 7:
                _context5.next = 9;
                return _this11.imageDirectoryHandle.requestPermission({ mode: 'readwrite' });

              case 9:
                _context5.t1 = _context5.sent;

                if (!(_context5.t1 === 'granted')) {
                  _context5.next = 12;
                  break;
                }

                hasPermission = true;

              case 12:
                if (!hasPermission) {
                  _context5.next = 17;
                  break;
                }

                _context5.next = 15;
                return _this11.imageDirectoryHandle.getFileHandle('test.jpeg', { create: true });

              case 15:
                handle = _context5.sent;

                _this11.writeURLToFile(handle, data);

              case 17:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this11);
      }))();
    },
    getNewFileHandle: function getNewFileHandle() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var options, handle;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                options = {
                  types: [{
                    description: 'Images',
                    accept: {
                      'image/jpeg': ['.jpeg']
                    }
                  }]
                };
                _context6.next = 3;
                return window.showSaveFilePicker(options);

              case 3:
                handle = _context6.sent;
                return _context6.abrupt('return', handle);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this12);
      }))();
    },
    writeURLToFile: function writeURLToFile(fileHandle, url) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var writable, response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return fileHandle.createWritable();

              case 2:
                writable = _context7.sent;
                _context7.next = 5;
                return fetch(url);

              case 5:
                response = _context7.sent;
                _context7.next = 8;
                return response.body.pipeTo(writable);

              case 8:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this13);
      }))();
    },
    downloadJob: function downloadJob(jobNumber) {
      var _this14 = this;

      this.logDialogTitle = 'Download Job';
      this.logDialogInfo = 'Download starting';
      this.logDialogLog = '';
      this.logDialog = true;
      this.generateZip(jobNumber, function (content, zipName) {
        _this14.logDialogLog += 'Zip file generated, downloading now\n';
        __WEBPACK_IMPORTED_MODULE_7_file_saver___default()(content, zipName + '.zip');
        _this14.logDialogInfo = 'Download complete';
        _this14.logDialogLog += 'Download complete\n';
      });
    },
    generateZip: function generateZip(jobNumber, zipCallback) {
      var _this15 = this;

      var zip = new __WEBPACK_IMPORTED_MODULE_8_jszip___default.a();

      var job = this.currentJob;
      job.template = this.templates;
      zip.file('Job Data.txt', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(job));
      this.logDialogLog += 'Job data added to zip\n';
      var promises = [];

      var _loop2 = function _loop2(template) {
        _this15.templates[template].items.map(function (obj, item) {
          promises.push(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var thisItem = _this15.templates[template].items[item];
            var title = thisItem.title;
            if (thisItem.image !== '') {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dbPromise__["a" /* default */])().then(function (db) {
                var tx = db.transaction('imageStore');
                var imageStore = tx.objectStore('imageStore');
                return imageStore.get(thisItem.image);
              }).then(function (image) {
                if (image !== undefined) {
                  // Prepare image for sending
                  var bytes = image.image;
                  zip.file(template + '-' + title + '.jpg', bytes.replace('data:image/jpeg;base64,', ''), { base64: true });
                  _this15.logDialogLog += title + ' image added to zip file\n';
                  resolve('image');
                }
              });
            } else if (thisItem.note) {
              _this15.logDialogLog += template + '-' + title + ' is a note, adding as text file\n';
              zip.file(template + '-' + title + '.txt', thisItem.note);
              resolve('note');
            } else {
              _this15.logDialogLog += template + '-' + title + ' is not a note or an image, may be an optional item which was skipped\n';
              resolve('no image');
            }
          }));
        });
      };

      for (var template in this.templates) {
        _loop2(template);
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (value) {
        zip.generateAsync({ type: 'blob' }).then(function (content) {
          var zipName = '';
          if (job.JobNo) {
            zipName = job.JobNo;
          } else if (job.reg) {
            zipName = job.reg;
          } else {
            zipName = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('X');
          }
          zipCallback(content, zipName);
          // saveAs(content, zipName + '.zip')
        });
      });
    },
    getExifData: function getExifData(image) {
      var view = new DataView(image);
      if (view.getUint16(0, false) !== 0xFFD8) return -2;
      var length = view.byteLength;
      var offset = 2;
      while (offset < length) {
        var marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966) return -1;
          var little = view.getUint16(offset += 6, false) === 0x4949;
          offset += view.getUint32(offset + 4, little);
          var tags = view.getUint16(offset, little);
          offset += 2;
          for (var i = 0; i < tags; i++) {
            if (view.getUint16(offset + i * 12, little) === 0x0112) {
              return view.getUint16(offset + i * 12 + 8, little);
            }
          }
        } else if ((marker & 0xFF00) !== 0xFF00) {
          break;
        } else {
          offset += view.getUint16(offset, false);
        }
      }
      return -1;
    }
  }
});

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dbPromise__ = __webpack_require__(28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      userid: this.$store.getters.user.id,
      jobs: [],
      loading: true,
      online: true
    };
  },

  computed: {
    hasCustomers: function hasCustomers() {
      return this.jobs.length > 0;
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__firebase__["c" /* firedb */].ref('/.info/connected').once('value').then(function (snap) {
      if (snap.val() === true) {
        _this.online = true;
        _this.getRemoteData();
      } else {
        _this.online = false;
        _this.getLocalData();
      }
    });
  },

  methods: {
    getRemoteData: function getRemoteData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* fireStore */].collection('Jobs').where('Allocated', '==', this.userid).get().then(function (snap) {
        if (snap !== null) {
          snap.forEach(function (doc) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dbPromise__["a" /* default */])().then(function (db) {
              var tx = db.transaction('jobStore', 'readwrite');
              var jobStore = tx.objectStore('jobStore');

              jobStore.put(doc.data(), doc.id);
              return tx.complete;
            }).then(function () {
              _this2.jobs.push(doc.data());
            });
          });
          _this2.loading = false;
        } else {
          _this2.loading = false;
        }
      });
    },
    getLocalData: function getLocalData() {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('jobStore');
        var jobStore = tx.objectStore('jobStore');
        return jobStore.getAll();
      }).then(function (val) {
        if (val.length > 0) {
          for (var job in val) {
            _this3.jobs.push(val[job]);
          }
        }
        _this3.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dbPromise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_StatusOverview_vue__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_StatusOverview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Shared_StatusOverview_vue__);
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    StatusOverview: __WEBPACK_IMPORTED_MODULE_2__Shared_StatusOverview_vue___default.a
  },
  data: function data() {
    return {
      snackbar: false,
      snackbarText: '',
      currentJob: false,
      snackbarTimeout: 1000
    };
  },

  firebase: {
    connected: __WEBPACK_IMPORTED_MODULE_1__firebase__["c" /* firedb */].ref('.info')
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  },
  mounted: function mounted() {
    this.checkCurrentJob();
  },

  methods: {
    checkCurrentJob: function checkCurrentJob() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('currentJob');
        var currentStore = tx.objectStore('currentJob');
        return currentStore.getAll();
      }).then(function (val) {
        if (val.length > 0) {
          _this.currentJob = false;
        } else {
          _this.currentJob = true;
        }
      });
    },
    refreshApp: function refreshApp() {
      window.location.reload(true);
    }
  }
});

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dbPromise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      online: true,
      assigning: false,
      activeJob: {},
      currentJob: {
        number: 0
      },
      customerFilter: '',
      startAlert: false,
      continueAlert: false,
      jobs: [],
      loading: false,
      templateStore: {},
      oldTemplateStore: {},
      snackbar: false,
      snackbarText: '',
      date: null,
      dateMenu: false,
      listView: true,
      outboxItems: [],
      selectCustomer: null,
      selectVehicle: null,
      inProgressJobs: [],
      inProgressKeys: {},
      selectEngineer: 1,
      includeCompleted: false,
      notesDialog: false,
      editNotes: '',
      noteEditId: null,
      savingNotes: false,
      jobFilter: '',
      templateSummary: []
    };
  },
  created: function created() {
    var _this = this;

    this.date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
    // this.getJobs()

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
      var tx = db.transaction('currentJob');
      var currentStore = tx.objectStore('currentJob');
      return currentStore.get(0);
    }).then(function (val) {
      if (val !== undefined) {
        _this.currentJob = val;
      }
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
      var tx = db.transaction('inProgressJobs');
      var inProgressJobsStore = tx.objectStore('inProgressJobs');
      return inProgressJobsStore.getAllKeys();
    }).then(function (keys) {
      keys.forEach(function (key) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('inProgressJobs');
          var inProgressJobsStore = tx.objectStore('inProgressJobs');
          return inProgressJobsStore.get(key);
        }).then(function (val) {
          if (val) {
            _this.inProgressJobs[key] = val;
            _this.inProgressKeys[val[0].number] = key;
          }
        });
      });
    });

    this.outboxItems = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
      var tx = db.transaction('outbox');
      var outboxStore = tx.objectStore('outbox');
      return outboxStore.getAllKeys();
    }).then(function (keys) {
      if (keys.length > 0) {
        keys.forEach(function (element) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
            return db.transaction('outbox').objectStore('outbox').get(element);
          }).then(function (val) {
            val.element = element;
            _this.outboxItems.push(val.number);
          });
        });
      }
    });

    this.resetTemplateObj();
  },

  watch: {
    date: function date() {
      if (!this.listView) {
        this.getJobs();
      }
    },
    listView: function listView(val) {
      if (!val) {
        this.getJobs();
      }
    },
    selectCustomer: function selectCustomer(val) {
      if (val) {
        this.selectVehicle = null;
      }
    },
    selectEngineer: function selectEngineer(val) {
      if (!this.listView) {
        this.getJobs();
      }
    }
  },
  computed: {
    engineerSelect: function engineerSelect() {
      var options = [{
        text: 'Your assigned jobs',
        value: 1
      }, {
        text: 'Unassigned jobs',
        value: -1
      }];
      if (this.user && this.user.company === '5BepIUcIKKTJbKBzjP9x') {
        options.push({
          text: 'All Engineers Jobs',
          value: -2
        });
      }
      return options;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    hasCustomers: function hasCustomers() {
      return this.jobs.length > 0;
    },
    dateFormatted: function dateFormatted() {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date).format('DD/MM/YYYY');
    },
    filteredJobs: function filteredJobs() {
      var _this2 = this;

      console.log('ger');
      var arr = this.jobs;
      if (this.selectCustomer) {
        arr = arr.filter(function (job) {
          return job.Customer === _this2.selectCustomer;
        });
      }
      return arr;
    },
    vehicleFilteredJobs: function vehicleFilteredJobs() {
      var _this3 = this;

      var arr = this.jobs;
      if (this.selectVehicle) {
        arr = arr.filter(function (job) {
          return job.Vehicle === _this3.selectVehicle;
        });
      }
      if (this.jobFilter) {
        arr = arr.filter(function (job) {
          return job.JobNo.includes(_this3.jobFilter);
        });
      }
      return arr;
    },
    customers: function customers() {
      if (this.customerFilter === null || this.customerFilter === undefined || this.customerFilter.length < 3) {
        return [];
      }
      return this.$store.getters.customers.sort(function (a, b) {
        var aName = a.name.toLowerCase();
        var bName = b.name.toLowerCase();
        return aName < bName ? -1 : aName > bName ? 1 : 0;
      });
    },
    vehicles: function vehicles() {
      return this.$store.getters.vehicles;
    },
    jobVehicles: function jobVehicles() {
      var _this4 = this;

      var arr = [];
      if (this.filteredJobs.length > 0) {
        this.filteredJobs.forEach(function (job) {
          if (job.Vehicle && _this4.vehicles) {
            var vehicleIndex = _this4.vehicles.findIndex(function (vehicle) {
              return vehicle.id === job.Vehicle;
            });
            if (vehicleIndex > -1 && _this4.vehicles[vehicleIndex]['VehicleReg']) {
              arr.push({ reg: _this4.vehicles[vehicleIndex]['VehicleReg'], id: job.Vehicle });
            }
          }
        });
      }
      return arr;
    }
  },
  filters: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('DD/MM/YYYY');
    }
  },
  methods: {
    saveNotes: function saveNotes() {
      var _this5 = this;

      this.savingNotes = true;
      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Jobs').doc(this.noteEditId).update({ notes: this.editNotes }).then(function () {
        _this5.getJobs();
        _this5.notesDialog = false;
        _this5.noteEditId = null;
        _this5.editNotes = '';
        _this5.savingNotes = false;
      }).catch(function () {
        _this5.savingNotes = false;
        alert('Something went wrong, unfortunately saving notes only works when you have an internet connection.');
      });
    },
    openEditNoteDialog: function openEditNoteDialog(job) {
      console.log(job);
      this.notesDialog = true;
      this.editNotes = job.notes;
      this.noteEditId = job.number;
    },
    resetTemplateObj: function resetTemplateObj() {
      var _this6 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('templates');
        var templateStore = tx.objectStore('templates');
        return templateStore.getAllKeys();
      }).then(function (keys) {
        keys.forEach(function (key) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
            var tx = db.transaction('templates');
            var templateStore = tx.objectStore('templates');
            return templateStore.get(key);
          }).then(function (val) {
            _this6.templateStore[key] = val;
          });
        });
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('oldTemplates');
        var templateStore = tx.objectStore('oldTemplates');
        return templateStore.getAllKeys();
      }).then(function (keys) {
        keys.forEach(function (key) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
            var tx = db.transaction('oldTemplates');
            var templateStore = tx.objectStore('oldTemplates');
            return templateStore.get(key);
          }).then(function (val) {
            _this6.oldTemplateStore[key] = val;
          });
        });
      });
    },
    assignJob: function assignJob() {
      var _this7 = this;

      this.assigning = true;
      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Jobs').doc(this.activeJob.number).update({ Allocated: this.user.id }).then(function () {
        _this7.activeJob.Allocated = _this7.user.id;
        _this7.assigning = false;
      });
    },
    getJobs: function getJobs() {
      var _this8 = this;

      this.loading = true;
      this.jobs = [];
      console.log('getting jobs');
      __WEBPACK_IMPORTED_MODULE_1__firebase__["c" /* firedb */].ref('/.info/connected').once('value').then(function (snap) {
        if (snap.val() === true) {
          console.log('1');
          _this8.online = true;
          _this8.getRemoteData();
        } else {
          console.log('2');
          _this8.online = false;
          _this8.getLocalData();
        }
      });
    },
    isCurrentJob: function isCurrentJob(job) {
      if (this.currentJob !== undefined) {
        return this.currentJob.number === job.number;
      } else {
        return false;
      }
    },
    startJob: function startJob() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Jobs').doc(this.activeJob.number).update({ jobStarted: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('x'), Allocated: this.user.id });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('currentJob', 'readwrite');
        var currentStore = tx.objectStore('currentJob');

        currentStore.put({
          Customer: _this9.activeJob.Customer,
          number: _this9.activeJob.number,
          reg: _this9.activeJob.vehReg,
          JobNo: _this9.activeJob.JobNo,
          imei: _this9.activeJob.imei,
          vehicle: _this9.activeJob.Vehicle,
          newMethod: _this9.activeJob.newMethod,
          jobLookupIds: _this9.activeJob.jobLookupIds,
          startTime: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('x'),
          notes: _this9.activeJob.notes || '',
          chargeable: false,
          requirements: _this9.activeJob.requirements,
          network: _this9.activeJob.network,
          ICCID: _this9.activeJob.ICCID,
          APN: _this9.activeJob.APN,
          newReg: _this9.activeJob.newReg,
          newMake: _this9.activeJob.newMake,
          newModel: _this9.activeJob.newModel,
          leaveKit: _this9.activeJob.leaveKit,
          getKit: _this9.activeJob.getKit
        }, 0);
        return tx.complete;
      }).then(function () {
        var templates = [];
        _this9.activeJob.templates.forEach(function (element) {
          if (_this9.templateStore[element] !== undefined && _this9.activeJob.newMethod) {
            templates.push(_this9.templateStore[element]);
          } else if (_this9.oldTemplateStore[element] !== undefined && !_this9.activeJob.newMethod) {
            templates.push(_this9.oldTemplateStore[element]);
          } else {
            console.log('undefined');
            _this9.snackbar = true;
            _this9.snackbarText = 'A required template is missing from your device. Refreshing.';
            _this9.refreshTemplates();
            _this9.refreshOldTemplates();
            return;
          }
        });
        if (_this9.snackbar === false) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
            var tx = db.transaction('currentJob', 'readwrite');
            var currentStore = tx.objectStore('currentJob');
            currentStore.put(templates, 1);
            return tx.complete;
          }).then(function () {
            _this9.$router.push('/CurrentJob');
          });
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
            var tx = db.transaction('currentJob', 'readwrite');
            var currentStore = tx.objectStore('currentJob');

            currentStore.clear();
            return tx.complete;
          });
        }
      });
    },
    continueJob: function continueJob() {
      var _this10 = this;

      var activeKey = this.inProgressKeys[this.activeJob.number];
      var activeJob = this.inProgressJobs[activeKey];
      activeJob[0].inProgressKey = activeKey;
      activeJob[1].forEach(function (element) {
        if (_this10.templateStore[element.id] === undefined) {
          console.log('undefined');
          _this10.snackbar = true;
          _this10.snackbarText = 'A required template is missing from your device. Refreshing.';
          _this10.refreshTemplates();
          _this10.refreshOldTemplates();
          return;
        }
      });
      if (this.snackbar === false) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('currentJob', 'readwrite');
          var currentStore = tx.objectStore('currentJob');
          currentStore.put(activeJob[0], 0);
          currentStore.put(activeJob[1], 1);
          return tx.complete;
        }).then(function () {
          _this10.$router.push('/CurrentJob');
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('currentJob', 'readwrite');
          var currentStore = tx.objectStore('currentJob');

          currentStore.clear();
          return tx.complete;
        });
      }
    },
    activateJob: function activateJob(job) {
      if (job.number === this.currentJob.number) {
        this.$router.push('/CurrentJob');
      } else if (this.inProgressKeys[job.number]) {
        this.activeJob = {
          number: job.number,
          Vehicle: job.Vehicle,
          vehReg: job.vehReg,
          notes: job.notes || '',
          chargeable: false,
          templates: job.templates,
          Customer: job.Customer,
          JobNo: job.JobNo,
          imei: job.imei,
          newMethod: job.newMethod,
          jobLookupIds: job.jobLookupIds || [],
          jobStarted: job.jobStarted,
          requirements: job.requirements,
          network: job.network,
          ICCID: job.ICCID,
          APN: job.APN,
          newReg: job.newReg,
          newMake: job.newMake,
          newModel: job.newModel,
          leaveKit: job.leaveKit,
          getKit: job.getKit
        };
        this.continueAlert = true;
      } else if (job.Status !== 2 && this.outboxItems.indexOf(job.number) === -1) {
        var imei = null;
        if (job.extras !== undefined) {
          imei = job.extras['[Track Smart] Calamp IMEI'] !== undefined ? job.extras['[Track Smart] Calamp IMEI'] : job.extras['[Trailer Smart Calamp] Calamp IMEI'] !== undefined ? job.extras['[Trailer Smart Calamp] Calamp IMEI'] : job.extras['IMEI'] !== undefined ? job.extras['IMEI'] : null;
        }
        if (job.templates.length === 2) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(job.templates), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var j = _step.value;

              if (this.templateStore[j] && this.templateStore[j].name.toLowerCase().indexOf('trailer') !== -1) {
                job.templates.splice(job.templates.indexOf('preCheck'), 1);
                break;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
        this.activeJob = {
          number: job.number,
          Vehicle: job.Vehicle,
          vehReg: job.vehReg,
          notes: job.notes || '',
          chargeable: false,
          templates: job.templates,
          Customer: job.Customer,
          JobNo: job.JobNo,
          Allocated: job.Allocated,
          imei: imei,
          newMethod: job.newMethod,
          jobLookupIds: job.jobLookupIds || [],
          jobStarted: job.jobStarted,
          requirements: job.requirements,
          network: job.network,
          ICCID: job.ICCID,
          APN: job.APN,
          newReg: job.newReg,
          newMake: job.newMake,
          newModel: job.newModel,
          leaveKit: job.leaveKit,
          getKit: job.getKit

        };
        this.templateSummary = [];
        for (var i = 0; i < this.activeJob.templates.length; i++) {
          if (this.templateStore[this.activeJob.templates[i]] !== undefined) {
            this.templateSummary.push(this.templateStore[this.activeJob.templates[i]].name);
          } else if (this.oldTemplateStore[this.activeJob.templates[i]] !== undefined) {
            this.templateSummary.push(this.oldTemplateStore[this.activeJob.templates[i]].name);
          }
        }
        console.log(this.templateSummary);
        this.startAlert = true;
      }
    },
    getRemoteData: function getRemoteData() {
      var _this11 = this;

      var ref = '';
      if (this.listView) {
        var statusValue = this.includeCompleted ? 2 : 0;
        if (this.selectCustomer === null || this.selectCustomer === undefined) {
          if (this.selectEngineer === -1) {
            ref = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Jobs').where('Supplier', '==', this.user.company).where('Allocated', '==', '').where('Status', '<=', statusValue);
          } else if (this.selectEngineer === -2) {
            ref = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Jobs').where('Supplier', '==', this.user.company).where('Status', '<=', statusValue);
          } else {
            ref = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Jobs').where('Allocated', '==', this.user.id).where('Status', '<=', statusValue);
          }
        } else {
          if (this.selectEngineer === -1) {
            ref = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Jobs').where('Supplier', '==', this.user.company).where('Allocated', '==', '').where('Status', '<=', statusValue).where('Customer', '==', this.selectCustomer);
          } else if (this.selectEngineer === -2) {
            ref = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Jobs').where('Supplier', '==', this.user.company).where('Status', '<=', statusValue).where('Customer', '==', this.selectCustomer);
          } else {
            ref = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Jobs').where('Allocated', '==', this.user.id).where('Status', '<=', statusValue).where('Customer', '==', this.selectCustomer);
          }
        }
      } else {
        if (this.selectEngineer === -1) {
          ref = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Jobs').where('Supplier', '==', this.user.company).where('Allocated', '==', '').where('Date', '<=', this.date).where('Date', '>=', this.date);
        } else if (this.selectEngineer === -2) {
          ref = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Jobs').where('Supplier', '==', this.user.company).where('Date', '<=', this.date).where('Date', '>=', this.date);
        } else {
          ref = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Jobs').where('Allocated', '==', this.user.id).where('Date', '<=', this.date).where('Date', '>=', this.date);
        }
      }
      ref.get().then(function (snap) {
        var jobs = [];
        if (snap !== null) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
            var tx = db.transaction('jobStore', 'readwrite');
            var jobStore = tx.objectStore('jobStore');

            jobStore.clear();
            return tx.complete;
          }).then(function () {
            snap.forEach(function (doc) {
              var data = doc.data();
              data.number = doc.id;
              if (data.Status === 2) {
                jobs.push(data);
              } else {
                jobs.unshift(data);
              }
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
                var tx = db.transaction('jobStore', 'readwrite');
                var jobStore = tx.objectStore('jobStore');

                jobStore.put(data, doc.id);
                return tx.complete;
              }).catch(function (error) {
                console.log(error);
              });
            });
            _this11.jobs = jobs;
            console.log(_this11.jobs);
            console.log(_this11.templateStore);
            _this11.loading = false;
          });
        } else {
          _this11.loading = false;
        }
      });
    },
    getLocalData: function getLocalData() {
      var _this12 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('jobStore');
        var jobStore = tx.objectStore('jobStore');
        return jobStore.get(_this12.number);
      }).then(function (val) {
        if (val !== undefined) {
          _this12.jobs.push(val);
        }
        _this12.loading = false;
      });
    },
    tomorrow: function tomorrow() {
      this.date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date).add('1', 'days').format('YYYY-MM-DD');
    },
    yesterday: function yesterday() {
      this.date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date).subtract('1', 'days').format('YYYY-MM-DD');
    },
    vehicleRegFromID: function vehicleRegFromID(id) {
      var index = this.vehicles.findIndex(function (vehicle) {
        return vehicle.id === id;
      });
      if (index > -1) {
        if (this.vehicles[index]['VehicleReg'] && this.vehicles[index]['VehicleReg'].length > 0) {
          return this.vehicles[index]['VehicleReg'];
        } else if (this.vehicles[index]['vehReg'] && this.vehicles[index]['vehReg'].length > 0) {
          return this.vehicles[index]['vehReg'];
        } else {
          return this.vehicles[index]['friendlyId'];
        }
      } else {
        return '';
      }
    },
    refreshTemplates: function refreshTemplates() {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('deviceType').get().then(function (snap) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('templates', 'readwrite');
          var currentStore = tx.objectStore('templates');
          currentStore.clear();
          return tx.complete;
        }).then(function () {
          snap.forEach(function (doc) {
            var data = doc.data();
            data.items.forEach(function (item) {
              item.image = '';
              item.note = '';
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
              var tx = db.transaction('templates', 'readwrite');
              var templateStore = tx.objectStore('templates');

              templateStore.put(data, doc.id);
              return tx.complete;
            }).then(function () {
              _this13.snackbar = true;
              _this13.snackbarText = 'Templates Refreshed - Try again';
              _this13.resetTemplateObj();
            });
          });
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    refreshOldTemplates: function refreshOldTemplates() {
      var _this14 = this;

      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* fireStore */].collection('Templates').get().then(function (snap) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('oldTemplates', 'readwrite');
          var currentStore = tx.objectStore('oldTemplates');
          currentStore.clear();
          return tx.complete;
        }).then(function () {
          snap.forEach(function (doc) {
            var data = doc.data();
            data.items.forEach(function (item) {
              item.image = '';
              item.note = '';
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dbPromise__["a" /* default */])().then(function (db) {
              var tx = db.transaction('oldTemplates', 'readwrite');
              var templateStore = tx.objectStore('oldTemplates');

              templateStore.put(data, doc.id);
              return tx.complete;
            }).then(function () {
              _this14.resetTemplateObj();
            });
          });
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dbPromise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__firebase__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_file_saver__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jszip__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_jszip__);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      jobs: [],
      customers: [],
      logDialog: false,
      logDialogTitle: null,
      logDialogLog: null,
      logDialogInfo: null,
      snackbar: false,
      snackbarText: '',
      snackbarIcon: ''
    };
  },
  created: function created() {
    this.getJobs();
    this.getCustomers();
  },

  filters: {
    customerNameFromId: function customerNameFromId(customerId, customers) {
      var customerObj = customers.find(function (customer) {
        return customerId === customer.id;
      });
      return customerObj ? customerObj.customerName : '';
    }
  },
  methods: {
    getJobs: function getJobs() {
      var _this = this;

      this.jobs = [];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('outbox');
        var outboxStore = tx.objectStore('outbox');
        return outboxStore.getAllKeys();
      }).then(function (keys) {
        if (keys.length > 0) {
          keys.forEach(function (element) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dbPromise__["a" /* default */])().then(function (db) {
              return db.transaction('outbox').objectStore('outbox').get(element);
            }).then(function (val) {
              val.element = element;
              _this.jobs.push(val);
            });
          });
        }
      });
    },
    getCustomers: function getCustomers() {
      var _this2 = this;

      this.customers = [];
      __WEBPACK_IMPORTED_MODULE_9__firebase__["b" /* fireStore */].collection('Customers').get().then(function (snap) {
        snap.forEach(function (doc) {
          var data = doc.data();
          data.id = doc.id;
          _this2.customers.push(data);
        });
      });
    },
    copyLog: function copyLog() {
      var _this3 = this;

      this.$copyText(this.logDialogLog).then(function (e) {
        _this3.snackbarIcon = 'file_copy';
        _this3.snackbarText = 'Log data copied to clipboard';
        _this3.snackbar = true;
      }).catch(function (e) {
        console.log(e);
      });
    },
    emailJob: function emailJob(jobNumber) {},
    downloadJob: function downloadJob(jobNumber) {
      var _this4 = this;

      this.logDialogTitle = 'Download Job';
      this.logDialogInfo = 'Download starting';
      this.logDialogLog = '';
      this.logDialog = true;
      this.generateZip(jobNumber, function (content, zipName) {
        _this4.logDialogLog += 'Zip file generated, downloading now\n';
        __WEBPACK_IMPORTED_MODULE_11_file_saver___default()(content, zipName + '.zip');
        _this4.logDialogInfo = 'Download complete';
        _this4.logDialogLog += 'Download complete\n';
      });
    },
    sendDebugLog: function sendDebugLog() {
      __WEBPACK_IMPORTED_MODULE_9__firebase__["b" /* fireStore */].collection('debug').add({ data: this.logDialogLog }).then(function (snap) {
        alert('Log Sent, ref: ' + snap.id);
      });
    },
    uploadJob: function uploadJob(jobNumber) {
      var _this5 = this;

      this.logDialogTitle = 'Upload Job';
      this.logDialogInfo = 'Upload in progress';
      this.logDialogLog = '';
      this.logDialog = true;

      var jobIndex = this.jobs.findIndex(function (jobObj) {
        return jobObj.number === jobNumber;
      });
      var job = this.jobs[jobIndex];
      var jobNumbers = [];
      var customerIndex = this.customers.findIndex(function (customer) {
        return job.Customer === customer.id;
      });
      var shortName = this.customers[customerIndex]['shortName'];

      __WEBPACK_IMPORTED_MODULE_9__firebase__["b" /* fireStore */].collection('Jobs').where('Customer', '==', job.Customer).get().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(snap) {
          var doc, val, _template, item, image, imageName, imageObj, updateSuccess, deleteImageStatus, clean, template, obj;

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  snap.forEach(function (doc) {
                    var JobNo = doc.data().JobNo;
                    if (JobNo && JobNo.indexOf(shortName) > -1) {
                      // This check is needed in case the short name has been changed. We only want to increment on job numbers with the new short name.
                      JobNo = JobNo.replace(/\D/g, '');
                      jobNumbers.push(JobNo);
                    }
                  });
                  jobNumbers.sort(function (a, b) {
                    return b - a;
                  });
                  if (!job.JobNo) {
                    job.JobNo = shortName + _this5.zeroFill(parseInt(jobNumbers[0]) + 1, 4);
                    _this5.logDialogLog += 'Job number not found, set to ' + job.JobNo + '\n';
                  } else {
                    _this5.logDialogLog += 'Job number = ' + job.JobNo + '\n';
                  }
                  if (!job.unscheduled) {
                    job.unscheduled = 0;
                    _this5.logDialogLog += 'Job is scheduled\n';
                  } else {
                    _this5.logDialogLog += 'Job is unscheduled\n';
                  }
                  if (!job.Date) {
                    job.Date = __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('YYYY-MM-DD');
                    _this5.logDialogLog += 'Job date not found, set to ' + job.Date + '\n';
                  } else {
                    _this5.logDialogLog += 'Job date = ' + job.Date + '\n';
                  }
                  if (job.vehicle === undefined || job.vehicle === '' || job.vehicle === null) {
                    job.vehicle = job.reg;
                    _this5.logDialogLog += 'vehicle not found, set to ' + job.vehicle + '\n';
                  } else {
                    _this5.logDialogLog += 'vehicle not = ' + job.vehicle + '\n';
                  }
                  if (job.imei === undefined || job.imei === null) {
                    job.imei = '';
                    _this5.logDialogLog += 'IMEI number not found\n';
                  } else {
                    _this5.logDialogLog += 'IMEI number = ' + job.imei + '\n';
                  }
                  doc = job.number;
                  val = job;

                  _this5.logDialogLog += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(val) + '\n';
                  _context.prev = 10;
                  _context.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(job.template);

                case 12:
                  if ((_context.t1 = _context.t0()).done) {
                    _context.next = 42;
                    break;
                  }

                  _template = _context.t1.value;

                  _this5.logDialogLog += 'Looping through templates. Current template = ' + _template + '\n';
                  _context.t2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(job.template[_template].items);

                case 16:
                  if ((_context.t3 = _context.t2()).done) {
                    _context.next = 40;
                    break;
                  }

                  item = _context.t3.value;
                  image = job.template[_template].items[item].image;
                  imageName = job.template[_template].items[item].imageName;

                  if (!(image && !imageName)) {
                    _context.next = 38;
                    break;
                  }

                  _context.next = 23;
                  return _this5.uploadImage(job, image);

                case 23:
                  imageObj = _context.sent;

                  job.template[_template].items[item].image = imageObj.ref;
                  job.template[_template].items[item].imageName = imageObj.name;
                  _context.next = 28;
                  return _this5.updateLocalJob(job, job.element);

                case 28:
                  updateSuccess = _context.sent;

                  if (!updateSuccess) {
                    _context.next = 37;
                    break;
                  }

                  _context.next = 32;
                  return _this5.deleteImageFromDB(image);

                case 32:
                  deleteImageStatus = _context.sent;

                  if (deleteImageStatus) {
                    _context.next = 35;
                    break;
                  }

                  throw new Error('Could not remove images');

                case 35:
                  _context.next = 38;
                  break;

                case 37:
                  throw new Error('Could not save state');

                case 38:
                  _context.next = 16;
                  break;

                case 40:
                  _context.next = 12;
                  break;

                case 42:
                  _context.next = 52;
                  break;

                case 44:
                  _context.prev = 44;
                  _context.t4 = _context['catch'](10);

                  _this5.logDialogLog += _context.t4.message + '\n';
                  _this5.sendDebugLog();
                  _this5.snackbar = true;
                  _this5.snackbarText = 'Failed to complete step 1 - Job not uploaded';
                  _this5.sending = false;
                  return _context.abrupt('return');

                case 52:
                  clean = function clean(object) {
                    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(object).forEach(function (_ref2) {
                      var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
                          k = _ref3[0],
                          v = _ref3[1];

                      if (v && (typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(v)) === 'object') {
                        clean(v);
                      }
                      if (v && (typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(v)) === 'object' && !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(v).length || v === null || v === undefined) {
                        if (Array.isArray(object)) {
                          object.splice(k, 1);
                        } else {
                          delete object[k];
                        }
                      }
                    });
                    return object;
                  };

                  _context.next = 55;
                  return clean(job.template || []);

                case 55:
                  template = _context.sent;
                  obj = {
                    Date: job.Date,
                    JobNo: job.JobNo,
                    Customer: job.Customer,
                    imei: job.imei,
                    template: template,
                    unscheduled: job.unscheduled,
                    Vehicle: job.vehicle,
                    vehicle: job.reg ? job.reg : '',
                    CompletedDate: job.CompletedDate,
                    startTime: job.startTime || null,
                    endTime: job.endTime || null,
                    notes: job.notes || null,
                    chargeable: job.chargeable || null
                  };

                  __WEBPACK_IMPORTED_MODULE_9__firebase__["b" /* fireStore */].collection('Jobs/').doc(doc).collection('CompletedJobs').doc().set(obj).then(function () {
                    __WEBPACK_IMPORTED_MODULE_9__firebase__["b" /* fireStore */].collection('Jobs/').doc(doc).update({ Status: 2, CompletedDate: job.CompletedDate, notes: job.notes || null, chargeable: job.chargeable || null });
                    // Data has been successful so safe to remove from IDB
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dbPromise__["a" /* default */])().then(function (db) {
                      var tx = db.transaction('outbox', 'readwrite');
                      var outboxStore = tx.objectStore('outbox');
                      outboxStore.delete(parseInt(job.element));
                    }).then(function () {
                      _this5.jobs.splice(jobIndex, 1);
                      _this5.logDialogInfo = 'Upload Complete';
                      _this5.snackbar = true;
                      _this5.snackbarText = 'Finished Sending';
                      _this5.sending = false;
                      _this5.sendDebugLog();
                    }).catch(function (error) {
                      _this5.logDialogLog += error.message + '\n';
                      _this5.snackbar = true;
                      _this5.snackbarText = 'Failed to complete step 3 - Job not uploaded';
                      _this5.sending = false;
                      _this5.sendDebugLog();
                    });
                  }).catch(function (error) {
                    _this5.logDialogLog += error.message + '\n';
                    _this5.snackbar = true;
                    _this5.snackbarText = 'Failed to complete step 2 - Job not uploaded';
                    _this5.sending = false;
                    _this5.sendDebugLog();
                  });

                case 58:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this5, [[10, 44]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      //   for (let template in val.template) {
      //     this.logDialogLog += 'Looping through templates. Current template = ' + template + '\n'
      //     val.template[template].items.map((obj, item) => {
      //       promises.push(new Promise((resolve, reject) => {
      //         const thisItem = val.template[template].items[item]
      //         if (thisItem.image !== '') {
      //           toDelete.push(thisItem.image)
      //           dbPromise().then(db => {
      //             let tx = db.transaction('imageStore')
      //             let imageStore = tx.objectStore('imageStore')
      //             return (imageStore.get(thisItem.image))
      //           })
      //           .then((image) => {
      //             if (image !== undefined) {
      //               // Prepare image for sending
      //               let bytes = image.image
      //               let ref = storage.ref(job.JobNo + '/' + image.name)
      //               this.logDialogLog += 'Image found. Image name = ' + image.name + '\n'
      //               this.logDialogLog += 'Sending image\n'
      //               // Send image
      //               console.info('Sending image')
      //               ref.putString(bytes, 'data_url', {cacheControl: 'only-if-cached'})
      //               .then((snapshot) => {
      //                 this.logDialogLog += 'Image ' + image.name + ' uploaded\n'
      //                 job.template[template].items[item].image = snapshot.downloadURL
      //                 job.template[template].items[item].imageName = image.name
      //                 console.log('uploaded')
      //                 resolve('resolved')
      //                 // Image has been successful so safe to remove from IDB
      //                 // On successful removal change flag and check if anything is still sending
      //               })
      //               .catch((error) => {
      //                 this.logDialogLog += 'Image ' + image.name + ' failed to upload\n'
      //                 console.log('rejected')
      //                 console.log(error)
      //                 reject('rejected')
      //               })
      //             }
      //           })
      //         } else {
      //           resolve('no image')
      //           this.logDialogLog += 'No image to upload\n'
      //         }
      //       }))
      //     })
      //   }
      //   Promise.all(promises)
      //   .then(async value => {
      //     this.logDialogLog += 'Image upload complete\n'
      //     if (value.indexOf('rejected') > -1) {
      //       this.logDialogLog += 'One or more images failed to upload. Stopping upload\n'
      //       this.snackbarText = 'Image upload failed. Please try again'
      //       this.snackbar = true
      //       return
      //     }
      //     const clean = (object) => {
      //       Object
      //         .entries(object)
      //         .forEach(([k, v]) => {
      //           if (v && typeof v === 'object') {
      //             clean(v)
      //           }
      //           if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined) {
      //             if (Array.isArray(object)) {
      //               object.splice(k, 1)
      //             } else {
      //               delete object[k]
      //             }
      //           }
      //         })
      //       return object
      //     }
      //     let template = await clean(job.template || [])
      //     this.logDialogLog += JSON.stringify(template)
      //     const obj = {
      //       Date: job.Date,
      //       JobNo: job.JobNo,
      //       Customer: job.Customer,
      //       imei: job.imei,
      //       template: template,
      //       unscheduled: job.unscheduled,
      //       Vehicle: job.vehicle,
      //       vehicle: job.reg ? job.reg : '',
      //       CompletedDate: job.CompletedDate,
      //       startTime: job.startTime || null,
      //       endTime: job.endTime || null
      //     }
      //     fireStore.collection('Jobs/').doc(doc).collection('CompletedJobs').doc()
      //     .set(obj)
      //     .then(() => {
      //       this.logDialogLog += 'Completed job saved in database\n'
      //       fireStore.collection('Jobs/').doc(doc).update({Status: 2, CompletedDate: job.CompletedDate})
      //       .then(ref => {
      //         this.logDialogLog += 'Status and completed date updated\n'
      //       })
      //       .catch(error => {
      //         console.log(error)
      //         this.logDialogLog += 'Job status was not updated\n'
      //       })
      //       // Data has been successful so safe to remove from IDB
      //       dbPromise().then(db => {
      //         let tx = db.transaction('outbox', 'readwrite')
      //         let outboxStore = tx.objectStore('outbox')
      //         outboxStore.delete(parseInt(job.element))
      //       })
      //       .then(() => {
      //         this.logDialogLog += 'Job removed from outbox\n'
      //         // this.getImages()
      //         for (let deleteIndex in toDelete) {
      //           dbPromise().then(db => {
      //             this.logDialogLog += 'Image deleted from storage\n'
      //             let tx = db.transaction('imageStore', 'readwrite')
      //             let imageStore = tx.objectStore('imageStore')
      //             imageStore.delete(toDelete[deleteIndex])
      //           })
      //         }
      //         this.jobs.splice(jobIndex, 1)
      //         this.logDialogInfo = 'Upload Complete'
      //         this.sendDebugLog()
      //       })
      //     })
      //     .catch(error => {
      //       console.log(error)
      //       this.logDialogLog += 'Completed job was not saved to the database\n'
      //       this.logDialogInfo = 'Upload Failed'
      //       this.sendDebugLog()
      //     })
      //   })
      //   .catch(reason => {
      //     this.logDialogLog += 'Image upload failed\n'
      //     this.logDialogLog += 'Reason: ' + reason + '\n'
      //     this.logDialogInfo = 'Upload Failed'
      //     this.sendDebugLog()
      //   })
      // })
    },
    uploadImage: function uploadImage(job, image) {
      var _this6 = this;

      console.log(image);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('imageStore');
        var imageStore = tx.objectStore('imageStore');
        return imageStore.get(image);
      }).then(function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(image) {
          var bytes, ref, response;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this6.logDialogLog += 'Sending image\n';

                  if (!image) {
                    _context2.next = 13;
                    break;
                  }

                  if (!(image.name === '1648904305868.jpg')) {
                    _context2.next = 5;
                    break;
                  }

                  _this6.logDialogLog += image.image;
                  return _context2.abrupt('return', { ref: '', name: image.name });

                case 5:
                  _this6.logDialogLog += 'Image found. Image name = ' + image.name + '\n';
                  bytes = image.image;
                  ref = __WEBPACK_IMPORTED_MODULE_9__firebase__["d" /* storage */].ref(job.JobNo + '/' + image.name);
                  _context2.next = 10;
                  return ref.putString(bytes, 'data_url', { cacheControl: 'only-if-cached' });

                case 10:
                  response = _context2.sent;

                  _this6.logDialogLog += 'Image ' + image.name + ' uploaded\n';
                  return _context2.abrupt('return', { ref: response, name: image.name, pathRef: ref });

                case 13:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this6);
        }));

        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }()).then(function () {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(snapshotObj) {
          var downloadURL;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return snapshotObj.pathRef.getDownloadURL();

                case 2:
                  downloadURL = _context3.sent;
                  return _context3.abrupt('return', { ref: downloadURL, name: snapshotObj.name });

                case 4:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this6);
        }));

        return function (_x3) {
          return _ref5.apply(this, arguments);
        };
      }());
    },
    updateLocalJob: function updateLocalJob(job, key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('outbox', 'readwrite');
        var outboxStore = tx.objectStore('outbox');

        outboxStore.put(job, key);
        return tx.complete;
      }).then(function () {
        return true;
      }).catch(function () {
        return false;
      });
    },
    deleteImageFromDB: function deleteImageFromDB(key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('imageStore', 'readwrite');
        var imageStore = tx.objectStore('imageStore');
        imageStore.delete(key);
        return true;
      }).catch(function () {
        return false;
      });
    },
    imageCount: function imageCount(job) {
      var imageCount = 0;
      var imagesSent = 0;
      for (var template in job.template) {
        for (var item in job.template[template].items) {
          if (job.template[template].items[item].image) {
            imageCount++;
            if (job.template[template].items[item].imageName) {
              imagesSent++;
            }
          }
        }
      }
      return { count: imageCount, sent: imagesSent };
    },
    deleteJob: function deleteJob(jobNumber) {
      var _this7 = this;

      this.logDialogTitle = 'Delete Job';
      this.logDialogInfo = 'Delete in progress';
      this.logDialogLog = '';
      this.logDialog = true;
      var jobIndex = this.jobs.findIndex(function (jobObj) {
        return jobObj.number === jobNumber;
      });
      var job = this.jobs[jobIndex];
      var val = job;
      var promises = [];

      var _loop = function _loop(template) {
        _this7.logDialogLog += 'Looping through templates. Current template = ' + template + '\n';
        val.template[template].items.map(function (obj, item) {
          promises.push(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var thisItem = val.template[template].items[item];
            if (thisItem.image !== '') {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dbPromise__["a" /* default */])().then(function (db) {
                var tx = db.transaction('imageStore', 'readwrite');
                var imageStore = tx.objectStore('imageStore');
                imageStore.delete(thisItem.image);
                _this7.logDialogLog += 'Image deleted from storage\n';
                resolve('deleted');
              }).catch(function (error) {
                console.log(error);
                resolve('not deleted');
              });
            } else {
              resolve('no image');
            }
          }));
        });
      };

      for (var template in val.template) {
        _loop(template);
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (value) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('outbox', 'readwrite');
          var outboxStore = tx.objectStore('outbox');
          outboxStore.delete(parseInt(job.element));
          _this7.logDialogLog += 'Job data deleted\n';
          _this7.jobs.splice(jobIndex, 1);
          _this7.logDialogLog += 'Job deleted\n';
          _this7.logDialogInfo = 'Job deleted';
        });
      });
    },
    generateZip: function generateZip(jobNumber, zipCallback) {
      var _this8 = this;

      var zip = new __WEBPACK_IMPORTED_MODULE_12_jszip___default.a();

      var job = this.jobs.find(function (jobObj) {
        return jobObj.number === jobNumber;
      });
      zip.file('Job Data.txt', __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(job));
      this.logDialogLog += 'Job data added to zip\n';
      var val = job;
      var promises = [];

      var _loop2 = function _loop2(template) {
        val.template[template].items.map(function (obj, item) {
          promises.push(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var thisItem = val.template[template].items[item];
            var title = thisItem.title;
            if (thisItem.image !== '') {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dbPromise__["a" /* default */])().then(function (db) {
                var tx = db.transaction('imageStore');
                var imageStore = tx.objectStore('imageStore');
                return imageStore.get(thisItem.image);
              }).then(function (image) {
                if (image !== undefined) {
                  // Prepare image for sending
                  var bytes = image.image;
                  zip.file(template + '-' + title + '.jpg', bytes.replace('data:image/jpeg;base64,', ''), { base64: true });
                  _this8.logDialogLog += title + ' image added to zip file\n';
                  resolve('image');
                }
              });
            } else if (thisItem.note) {
              _this8.logDialogLog += template + '-' + title + ' is a note, adding as text file\n';
              zip.file(template + '-' + title + '.txt', thisItem.note);
              resolve('note');
            } else {
              _this8.logDialogLog += template + '-' + title + ' is not a note or an image, may be an optional item which was skipped\n';
              resolve('no image');
            }
          }));
        });
      };

      for (var template in val.template) {
        _loop2(template);
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (value) {
        zip.generateAsync({ type: 'blob' }).then(function (content) {
          var zipName = '';
          if (job.JobNo) {
            zipName = job.JobNo;
          } else if (job.reg) {
            zipName = job.reg;
          } else {
            zipName = __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('X');
          }
          zipCallback(content, zipName);
          // saveAs(content, zipName + '.zip')
        });
      });
    }
  }
});

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idb__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dbPromise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase__ = __webpack_require__(12);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      items: [{ icon: 'history', iconClass: 'grey lighten-1 white--text', title: 'Reset', subtitle: 'Refresh the app to get the latest version', action: this.resetApp }, { icon: 'delete', iconClass: 'grey lighten-1 white--text', title: 'Clear All Data', subtitle: 'Clear all the data on app', action: this.clearApp }, { icon: 'cloud_download', iconClass: 'grey lighten-1 white--text', title: 'Get Data', subtitle: 'Get data from app', action: this.getData }],
      snackbar: false,
      snackbarText: '',
      cameraQuality: 0,
      jobQueue: {},
      jobQueueArray: [],
      sending: 0,
      sendingJob: -1,
      debug: ''
    };
  },

  watch: {
    cameraQuality: function cameraQuality(val) {
      localStorage.setItem('cameraQuality', val);
    }
  },
  created: function created() {
    this.getJobQueue();
    this.cameraQuality = localStorage.getItem('cameraQuality') !== null && localStorage.getItem('cameraQuality') !== undefined ? localStorage.cameraQuality : 50;
  },

  computed: {
    customers: function customers() {
      return this.$store.getters.customers;
    }
  },
  methods: {
    resetApp: function resetApp() {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(registrations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var registration = _step.value;

            registration.unregister();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }).then(function (boolean) {
        caches.delete('v1-engineer-cache').then(function (boolean) {
          window.location.reload(true);
        });
      });
    },
    clearApp: function clearApp() {
      var _this = this;

      this.snackbar = true;
      this.snackbarText = 'Clearing Data';
      __WEBPACK_IMPORTED_MODULE_2_idb___default.a.delete('engineer-db').then(function () {
        _this.snackbar = true;
        _this.snackbarText = 'Data Cleared';
      });
    },
    getData: function getData() {
      var text = '';
      var images = '';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('outbox');
        var outboxStore = tx.objectStore('outbox');
        return outboxStore.getAll();
      }).then(function (val) {
        text += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val);
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', 'text.txt');

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('imageStore');
        var outboxStore = tx.objectStore('imageStore');
        return outboxStore.getAll();
      }).then(function (val) {
        images += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val);
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(images));
        element.setAttribute('download', 'images.txt');

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
      });
    },
    uploadJob: function uploadJob(jobKey) {
      var _this2 = this;

      this.sendingJob = jobKey;
      // Get single outbox item
      this.debug += 'Preparing to send key:' + jobKey + '\n';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('outbox');
        var outboxStore = tx.objectStore('outbox');
        return outboxStore.get(jobKey);
      }).then(function (val) {
        // let jobNumber = val.number
        var job = val;
        var jobNumbers = [];
        var customerIndex = _this2.customers.findIndex(function (customer) {
          return job.customer === customer.id;
        });
        var shortName = _this2.customers[customerIndex]['shortName'];

        __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Jobs').where('Customer', '==', job.customer).get().then(function (snap) {
          snap.forEach(function (doc) {
            jobNumbers.push(doc.data().JobNo.replace(shortName, ''));
          });
          jobNumbers.sort(function (a, b) {
            return b - a;
          });
          job.JobNo = shortName + _this2.zeroFill(parseInt(jobNumbers[0]) + 1, 4);
          console.log(job);
          var templates = [];
          if (job.templates) {
            templates = job.templates;
          }
          var unscheduled = 0;
          if (job.unscheduled) {
            unscheduled = job.unscheduled;
          }
          __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Jobs').add({ JobNo: job.JobNo, Customer: job.customer, Date: job.Date, Vehicle: job.vehicle, templates: templates, unscheduled: unscheduled }).then(function (docRef) {
            var doc = docRef.id;
            var jobNumber = job.JobNo;
            var toDelete = [];
            _this2.debug += 'Job Number is:' + jobNumber + '\n';

            var _loop = function _loop(template) {
              _this2.debug += 'Looping Templates Pass' + template + '\n';

              var _loop2 = function _loop2(item) {
                _this2.debug += 'Looping Templates Items Pass' + item + '\n';
                if (val.template[template].items[item].image !== '') {
                  _this2.debug += item + 'Has Image! \n';
                  toDelete.push(val.template[template].items[item].image);
                  _this2.debug += item + 'Added to delete queue! \n';
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
                    var tx = db.transaction('imageStore');
                    var imageStore = tx.objectStore('imageStore');
                    return imageStore.get(val.template[template].items[item].image);
                  }).then(function (image) {
                    if (image !== undefined) {
                      _this2.debug += item + 'Successfully retreived image from local db! \n';
                      // Prepare image for sending
                      var bytes = image.image;
                      var ref = __WEBPACK_IMPORTED_MODULE_4__firebase__["d" /* storage */].ref(jobNumber + '/' + image.name);
                      _this2.sending++;
                      // Send image
                      console.info('Sending image');
                      ref.putString(bytes, 'data_url', { cacheControl: 'only-if-cached' }).then(function (snapshot) {
                        job.template[template].items[item].image = snapshot.downloadURL;
                        job.template[template].items[item].imageName = image.name;
                        // Image has been successful so safe to remove from IDB
                        // On successful removal change flag and check if anything is still sending
                        _this2.sending--;
                        console.log(_this2.sending);
                        _this2.debug += _this2.sending + 'Successfully Uploaded Image! \n';
                        if (_this2.sending === 0) {
                          _this2.debug += 'All Images Have been uploaded! \n';
                          // If all images have been sent -> send data
                          __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Jobs/').doc(doc).collection('CompletedJobs').doc().set(job).then(function () {
                            __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Jobs/').doc(doc).update({ Status: 2 });
                            _this2.debug += 'Job data sent! \n';
                            // Data has been successful so safe to remove from IDB
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
                              var tx = db.transaction('outbox', 'readwrite');
                              var outboxStore = tx.objectStore('outbox');
                              outboxStore.delete(parseInt(jobKey));
                            }).then(function () {
                              _this2.debug += 'Cleared local data! \n';
                              _this2.snackbar = true;
                              _this2.snackbarText = 'Upload Successful';

                              var _loop3 = function _loop3(i) {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
                                  this.debug += 'Cleared local images! \n';
                                  var tx = db.transaction('imageStore', 'readwrite');
                                  var imageStore = tx.objectStore('imageStore');
                                  imageStore.delete(toDelete[i]);
                                });
                              };

                              for (var i in toDelete) {
                                _loop3(i);
                              }
                            });
                          });
                          _this2.debug += 'Finished sending! \n';
                          _this2.snackbar = true;
                          _this2.snackbarText = 'Finished Sending';
                          _this2.getJobQueue();
                        }
                      }).catch(function (error) {
                        _this2.sendingJob = -1;
                        _this2.sending--;
                        console.log(error);
                        _this2.snackbarText = 'Unable to send. Will try later';
                        _this2.snackbar = true;
                        _this2.debug += 'Error:' + error.message + '! \n';
                      });
                    } else {
                      _this2.debug += item + 'No Image found in local db! \n';
                    }
                  });
                }
              };

              for (var item in val.template[template].items) {
                _loop2(item);
              }
            };

            for (var template in val.template) {
              _loop(template);
            }
          });
        });
      });
    },
    getJobQueue: function getJobQueue() {
      var _this3 = this;

      this.jobQueueArray = [];
      this.sendingJob = -1;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('outbox');
        var outboxStore = tx.objectStore('outbox');
        return outboxStore.getAllKeys();
      }).then(function (keys) {
        for (var key in keys) {
          if (keys.hasOwnProperty(key)) {
            (function () {
              var element = keys[key];
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
                var tx = db.transaction('outbox');
                var outboxStore = tx.objectStore('outbox');
                return outboxStore.get(element);
              }).then(function (val) {
                _this3.jobQueue[element] = val;
                _this3.jobQueueArray.push(element);
              });
            })();
          }
        }
      });
    },
    zeroFill: function zeroFill(number, width) {
      width -= number.toString().length;
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
      }
      return number;
    }
  }
});

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['text'],
  methods: {
    onClose: function onClose() {
      this.$emit('dismissed');
    }
  }
});

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['dialog'],
  data: function data() {
    return {};
  },

  methods: {
    acceptDisclaimer: function acceptDisclaimer() {
      this.$emit('update:dialog', false);
    },
    declineDisclaimer: function declineDisclaimer() {
      this.$router.push('/');
    }
  }
});

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatusOverview',
  data: function data() {
    return {
      gettingData: false,
      data: [],
      jobsNotStarted: 0,
      jobsStarted: 0,
      jobsCompleted: 0,
      jobsNotUploaded: 0,
      listener: null,
      completedDialog: false,
      completedJobs: []
    };
  },
  created: function created() {
    this.getData();
  },
  beforeDestroy: function beforeDestroy() {
    this.listener();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.gettingData = true;
      this.listener = __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* fireStore */].collection('Jobs').where('Allocated', '==', this.user.id).orderBy('CompletedDate', 'desc').onSnapshot(function (snap) {
        _this.data = [];
        _this.jobsNotStarted = 0;
        _this.jobsStarted = 0;
        _this.jobsCompleted = 0;
        _this.jobsNotUploaded = 0;
        _this.completedJobs = [];
        snap.forEach(function (doc) {
          if (doc.data().CompletedDate) {
            if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(doc.data().CompletedDate) < __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(-14, 'days')) {
              return;
            }
            _this.jobsCompleted++;
            _this.completedJobs.push(doc.data());
          } else if (!doc.data().jobStarted) {
            _this.jobsNotStarted++;
            console.log(doc.data());
          } else if (doc.data().jobEnded) {
            _this.jobsNotUploaded++;
          } else {
            _this.jobsStarted++;
          }
          _this.data.push(doc.data());
        });
        _this.gettingData = false;
      });
    },
    vehicleRegFromID: function vehicleRegFromID(id) {
      var index = this.vehicles.findIndex(function (vehicle) {
        return vehicle.id === id;
      });
      if (index > -1) {
        return this.vehicles[index]['VehicleReg'];
      } else {
        return '';
      }
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    vehicles: function vehicles() {
      return this.$store.getters.vehicles;
    }
  },
  filters: {
    formatDate: function formatDate(val) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(val).format('DD/MM/YYYY');
    }
  }
});

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['dialog'],
  methods: {
    update: function update() {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(registrations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var registration = _step.value;

            registration.unregister();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }).then(function (boolean) {
        caches.delete('v1-engineer-cache').then(function (boolean) {
          window.location.reload(true);
        });
      });
    }
  }
});

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase__ = __webpack_require__(12);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['testID', 'testType'],
  watch: {
    testType: function testType(val) {
      if (val === 'IMEI') {
        this.IDType = {
          name: 'IMEI',
          type: 'IMEI'
        };
      } else {
        this.IDType = {
          name: 'DVR ID',
          type: 'DVRID'
        };
      }
    },
    testID: function testID(val) {
      this.ID = val;
    }
  },
  data: function data() {
    return {
      ID: '',
      error: '',
      date: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
      selectionHint: '',
      extraNotes: '',
      time: '00:00',
      results: {},
      fileList: [],
      messageSent: false,
      IDSelections: [{ name: 'IMEI', type: 'IMEI' }, { name: 'DVR ID', type: 'DVRID' }],
      IDType: {
        name: 'IMEI',
        type: 'IMEI'
      },
      dateModal: false,
      gettingResults: false,
      connectedSince: 30,
      notesSaved: false,
      connectedSinceItems: [{ text: '30 minutes', value: 30 }, { text: '1 hour', value: 60 }, { text: '6 hours', value: 360 }, { text: '24 hours', value: 1440 }],
      notesDialog: false,
      savingNotes: false,
      sendingMessage: false,
      messageTemplates: [{ text: 'CALAMP - DVR On (Out 1 Clear)', value: '!R3,9,1' }, { text: 'CALAMP - DVR Off (Out 1 Set)', value: '!R3,8,1' }, { text: 'CALAMP - Side Scan Mute On (Out 0 Clear)', value: '!R3,9,0' }, { text: 'CALAMP - Side Scan Mute Off (Out 0 Set)', value: '!R3,8,0' }, { text: 'CALAMP - DAP Panel Off (Out 2 Clear)', value: '!R3,9,2' }, { text: 'CALAMP - DAP Panel On (Out 2 Set)', value: '!R3,8,2' }],
      message: ''
    };
  },

  methods: {
    saveExtraDetails: function saveExtraDetails() {
      var _this = this;

      var promises = [];
      var downloadUrls = [];
      this.savingNotes = true;
      var storageRef = __WEBPACK_IMPORTED_MODULE_4__firebase__["d" /* storage */].ref('DeviceTests/' + this.results.testId);

      var _loop = function _loop(file) {
        promises.push(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var uploadTask = storageRef.child(file.name).put(file);
          uploadTask.on('state_changed', function (snapshot) {}, function (error) {
            reject(error);
          }, function () {
            uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              downloadUrls.push({ downloadUrl: downloadURL, name: file.name });
              resolve();
            });
          });
        }));
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.fileList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var file = _step.value;

          _loop(file);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(promises).then(function (val) {
        __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('Devices').doc(_this.results.SerialNumber).collection('tests').doc(_this.results.testId).set({
          notes: _this.extraNotes,
          files: downloadUrls
        }, { merge: true }).then(function (docRef) {
          _this.notesSaved = true;
          _this.savingNotes = false;
          _this.notesDialog = false;
        }).catch(function (error) {
          _this.savingNotes = false;
          alert('Something went wrong :(. Try saving again.');
          console.log(error);
        });
      }).catch(function (error) {
        _this.savingNotes = false;
        alert('Something went wrong :(. Try saving again.');
        console.log(error);
      });
    },
    sendMessage: function sendMessage() {
      var _this2 = this;

      this.sendingMessage = true;
      var messageData = [];
      messageData.push({
        messageType: 1,
        ICCID: this.results.ICCID,
        message: btoa(this.message)
      });
      __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* fireStore */].collection('SIMmessages').add({
        messages: messageData,
        time: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD HH:mm'),
        user: this.$store.getters.user.name
      }).then(function (val) {
        _this2.sendingMessage = false;
        _this2.messageSent = true;
      }).catch(function (error) {
        _this2.sendingMessage = false;
        alert('Unexpected Error Occured');
        console.log(error);
      });
    },
    testDevice: function testDevice() {
      var _this3 = this;

      this.error = '';
      var toSend = {
        ID: this.ID,
        user: this.$store.getters.user,
        IDType: this.IDType.type
      };
      this.gettingResults = true;
      var url = 'https://us-central1-engineer-ae17e.cloudfunctions.net/runDeviceTest';
      fetch(url, {
        headers: { 'content-type': 'application/json; charset=UTF-8' },
        method: 'POST',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(toSend)
      }, { mode: 'cors' }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.error) {
          _this3.error = data.error;
          _this3.results = [];
          _this3.gettingResults = false;
          _this3.extraNotes = '';
          _this3.fileList = [];
          _this3.$emit('testId', -1);
          return;
        }
        _this3.$emit('testId', data.SerialNumber + '/tests/' + data.testId);
        _this3.results = data;
        _this3.gettingResults = false;
        _this3.extraNotes = '';
        _this3.fileList = [];
        _this3.$nextTick(function () {
          setTimeout(function () {
            _this3.$vuetify.goTo(_this3.$refs.connectedSince);
          }, 200);
        });
      });
    },
    compareDate: function compareDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.results.time).diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYYMMDDHHmmss'), 'minutes') < this.connectedSince;
    },
    setCustomDate: function setCustomDate() {
      this.dateModal = false;
      this.selectionHint = 'Since: ' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date + ' ' + this.time).format('DD/MM/YYYY HH:mm');
      this.connectedSince = __WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date + ' ' + this.time), 'minutes');
    },
    addFiles: function addFiles(e) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(e.target.files), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var file = _step2.value;

          this.fileList.push(file);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.$refs.value = '';
    }
  },
  filters: {
    formatDate: function formatDate(val) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(val, 'YYYYMMDDHHmmss').format('DD/MM/YYYY HH:mm:ss');
    }
  }
});

/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dbPromise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__firebase__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      images: [],
      sending: !!sessionStorage.getItem('isSending'),
      snackbar: false,
      snackbarText: ''
    };
  },

  computed: {
    imageCount: function imageCount() {
      return this.images.length;
    },
    showOutboxCount: function showOutboxCount() {
      return this.images.length > 0;
    },
    outboxColor: function outboxColor() {
      if (this.sending) {
        return 'green';
      } else {
        return 'secondary';
      }
    },
    customers: function customers() {
      return this.$store.getters.customers;
    }
  },
  mounted: function mounted() {
    this.getImages();
    this.uploadFile();
  },

  watch: {
    customers: function customers(val) {
      if (val.length) {
        this.uploadFile();
      }
    }
  },
  methods: {
    getImages: function getImages() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('outbox');
        var outboxStore = tx.objectStore('outbox');
        return outboxStore.getAll();
      }).then(function (val) {
        _this.images = val;
      });
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      if (!this.customers.length) {
        return;
      }
      // get keys to items in outbox
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('outbox');
        var outboxStore = tx.objectStore('outbox');
        return outboxStore.getAllKeys();
      }).then(function (keys) {
        if (keys.length > 0) {
          if (sessionStorage.getItem('isSending') === 'true') {
            _this2.snackbar = true;
            _this2.snackbarText = 'Sending Already In Progress';
            return;
          }
          _this2.sending = true;
          sessionStorage.setItem('isSending', 'true');
          // if there are items in outbox try and send the first
          var element = keys[0];
          _this2.snackbar = true;
          _this2.snackbarText = 'Sending Completed Jobs';
          // Get single outbox item
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__dbPromise__["a" /* default */])().then(function (db) {
            return db.transaction('outbox').objectStore('outbox').get(element);
          }).then(function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(val) {
              var job, customerIndex, shortName, jobNumbers;
              return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      // Call to jobs collection where customer = job customer
                      // Store job numbers in array, strip customer prefix, reverse sort array
                      // Latest job number is arr[0]
                      // Add 1, add customer prefix to get job number
                      // Create empty job doc with this job number to 'reserve' the job number to avoid duplicates being created elsewhere
                      console.log(val);
                      job = val;
                      customerIndex = _this2.customers.findIndex(function (customer) {
                        return job.Customer === customer.id;
                      });
                      shortName = _this2.customers[customerIndex]['shortName'];

                      if (job.JobNo) {
                        _context.next = 9;
                        break;
                      }

                      _context.next = 7;
                      return _this2.getJobNumbers(job.Customer, shortName);

                    case 7:
                      jobNumbers = _context.sent;

                      job.JobNo = shortName + _this2.zeroFill(parseInt(jobNumbers[0]) + 1, 4);

                    case 9:
                      console.log(job);
                      if (!job.unscheduled) {
                        job.unscheduled = 0;
                      }
                      if (!job.Date) {
                        job.Date = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD');
                      }
                      if (job.vehicle === undefined || job.vehicle === '' || job.vehicle === null) {
                        job.vehicle = job.reg;
                      }
                      if (job.imei === undefined || job.imei === null) {
                        job.imei = '';
                      }
                      _this2.next(job.number, job, element);

                    case 15:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, _this2);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        } else {
          _this2.sending = false;
          _this2.snackbarText = 'Nothing To Do';
          sessionStorage.removeItem('isSending');
        }
      });
    },
    getJobNumbers: function getJobNumbers(customer, shortName) {
      return __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* fireStore */].collection('Jobs').where('Customer', '==', customer).get().then(function (snap) {
        var jobNumbers = [];
        snap.forEach(function (doc) {
          var JobNo = doc.data().JobNo;
          if (JobNo && JobNo.indexOf(shortName) > -1) {
            // This check is needed in case the short name has been changed. We only want to increment on job numbers with the new short name.
            JobNo = JobNo.replace(/\D/g, '');
            jobNumbers.push(JobNo);
          }
        });
        return jobNumbers.sort(function (a, b) {
          return b - a;
        });
      });
    },

    // next (doc, job, element) { //OLD UPLOAD PROCESS
    //   let val = job
    //   let toDelete = []
    //   for (let template in val.template) {
    //     for (let item in val.template[template].items) {
    //       if (val.template[template].items[item].image !== '') {
    //         toDelete.push(val.template[template].items[item].image)
    //         dbPromise().then(function (db) {
    //           let tx = db.transaction('imageStore')
    //           let imageStore = tx.objectStore('imageStore')
    //           return (imageStore.get(val.template[template].items[item].image))
    //         })
    //         .then((image) => {
    //           if (image !== undefined) {
    //             // Prepare image for sending
    //             let bytes = image.image
    //             let ref = storage.ref(job.JobNo + '/' + image.name)
    //             this.sending++
    //             // Send image
    //             console.info('Sending image')
    //             ref.putString(bytes, 'data_url', {cacheControl: 'only-if-cached'})
    //             .then((snapshot) => {
    //               job.template[template].items[item].image = snapshot.downloadURL
    //               // Image has been successful so safe to remove from IDB
    //               // On successful removal change flag and check if anything is still sending
    //               this.sending--
    //               console.log(this.sending)
    //               if (this.sending === 0) {
    //                 // If all images have been sent -> send data
    //                 fireStore.collection('Jobs/').doc(doc).collection('CompletedJobs').doc()
    //                 .set(job)
    //                 .then(() => {
    //                   fireStore.collection('Jobs/').doc(doc).update({Status: 2})
    //                   // Data has been successful so safe to remove from IDB
    //                   dbPromise().then(function (db) {
    //                     let tx = db.transaction('outbox', 'readwrite')
    //                     let outboxStore = tx.objectStore('outbox')
    //                     outboxStore.delete(parseInt(element))
    //                   }).then(() => {
    //                     this.snackbar = true
    //                     this.snackbarText = 'Upload Successful'
    //                     this.getImages()
    //                     for (let i in toDelete) {
    //                       dbPromise().then(function (db) {
    //                         let tx = db.transaction('imageStore', 'readwrite')
    //                         let imageStore = tx.objectStore('imageStore')
    //                         imageStore.delete(toDelete[i])
    //                       })
    //                     }
    //                     this.uploadFile()
    //                     this.snackbar = true
    //                     this.snackbarText = 'Finished Sending'
    //                   })
    //                   .catch(error => {
    //                     console.log(error)
    //                     this.snackbarText = 'Error updating status'
    //                     this.snackbar = true
    //                   })
    //                 })
    //                 .catch(error => {
    //                   console.log(error)
    //                   this.snackbarText = 'Error setting completed job'
    //                   this.snackbar = true
    //                 })
    //               }
    //             })
    //             .catch((error) => {
    //               this.sending--
    //               console.log(error)
    //               this.snackbarText = 'Unable to send. Will try later'
    //               this.snackbar = true
    //             })
    //           }
    //         })
    //       }
    //     }
    //   }
    // },
    next: function next(doc, job, element) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _template, item, image, imageName, imageObj, updateSuccess, deleteImageStatus, clean, template, obj;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.t0 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.keys(job.template);

              case 2:
                if ((_context2.t1 = _context2.t0()).done) {
                  _context2.next = 31;
                  break;
                }

                _template = _context2.t1.value;
                _context2.t2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.keys(job.template[_template].items);

              case 5:
                if ((_context2.t3 = _context2.t2()).done) {
                  _context2.next = 29;
                  break;
                }

                item = _context2.t3.value;
                image = job.template[_template].items[item].image;
                imageName = job.template[_template].items[item].imageName;

                if (!(image && !imageName)) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 12;
                return _this3.uploadImage(job, image);

              case 12:
                imageObj = _context2.sent;

                job.template[_template].items[item].image = imageObj.ref;
                job.template[_template].items[item].imageName = imageObj.name;
                _context2.next = 17;
                return _this3.updateLocalJob(job, element);

              case 17:
                updateSuccess = _context2.sent;

                if (!updateSuccess) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 21;
                return _this3.deleteImageFromDB(image);

              case 21:
                deleteImageStatus = _context2.sent;

                if (deleteImageStatus) {
                  _context2.next = 24;
                  break;
                }

                throw new Error('Could not remove images');

              case 24:
                _context2.next = 27;
                break;

              case 26:
                throw new Error('Could not save state');

              case 27:
                _context2.next = 5;
                break;

              case 29:
                _context2.next = 2;
                break;

              case 31:
                _context2.next = 41;
                break;

              case 33:
                _context2.prev = 33;
                _context2.t4 = _context2['catch'](0);

                alert('Failed to complete step 1 - Job not uploaded. Please attempt via outbox.');
                _this3.snackbar = true;
                _this3.snackbarText = _context2.t4.message;
                _this3.sending = false;
                sessionStorage.removeItem('isSending');
                return _context2.abrupt('return');

              case 41:
                clean = function clean(object) {
                  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(object).forEach(function (_ref2) {
                    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
                        k = _ref3[0],
                        v = _ref3[1];

                    if (v && (typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(v)) === 'object') {
                      clean(v);
                    }
                    if (v && (typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(v)) === 'object' && !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(v).length || v === null || v === undefined) {
                      if (Array.isArray(object)) {
                        object.splice(k, 1);
                      } else {
                        delete object[k];
                      }
                    }
                  });
                  return object;
                };

                _context2.next = 44;
                return clean(job.template || []);

              case 44:
                template = _context2.sent;
                obj = {
                  Date: job.Date,
                  JobNo: job.JobNo,
                  Customer: job.Customer,
                  imei: job.imei,
                  template: template,
                  unscheduled: job.unscheduled,
                  Vehicle: job.vehicle,
                  vehicle: job.reg ? job.reg : '',
                  CompletedDate: job.CompletedDate,
                  startTime: job.startTime || null,
                  endTime: job.endTime || null,
                  notes: job.notes || null,
                  chargeable: job.chargeable || null
                };

                __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* fireStore */].collection('Jobs/').doc(doc).collection('CompletedJobs').doc().set(obj).then(function () {
                  __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* fireStore */].collection('Jobs/').doc(doc).update({ Status: 2, CompletedDate: job.CompletedDate, notes: job.notes || null, chargeable: job.chargeable || null });
                  // Data has been successful so safe to remove from IDB
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__dbPromise__["a" /* default */])().then(function (db) {
                    var tx = db.transaction('outbox', 'readwrite');
                    var outboxStore = tx.objectStore('outbox');
                    outboxStore.delete(parseInt(element));
                  }).then(function () {
                    _this3.getImages();
                    _this3.uploadFile();
                    _this3.snackbar = true;
                    _this3.snackbarText = 'Finished Sending';
                    _this3.sending = false;
                    sessionStorage.removeItem('isSending');
                  }).catch(function () {
                    _this3.snackbar = true;
                    _this3.snackbarText = 'Failed to complete step 3 - Job not uploaded';
                    _this3.sending = false;
                    sessionStorage.removeItem('isSending');
                  });
                }).catch(function () {
                  _this3.snackbar = true;
                  _this3.snackbarText = 'Failed to complete step 2 - Job not uploaded';
                  _this3.sending = false;
                  sessionStorage.removeItem('isSending');
                });

              case 47:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 33]]);
      }))();
    },
    uploadImage: function uploadImage(job, image) {
      var _this4 = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('imageStore');
        var imageStore = tx.objectStore('imageStore');
        return imageStore.get(image);
      }).then(function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3(image) {
          var bytes, ref, response;
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!image) {
                    _context3.next = 7;
                    break;
                  }

                  bytes = image.image;
                  ref = __WEBPACK_IMPORTED_MODULE_7__firebase__["d" /* storage */].ref(job.JobNo + '/' + image.name);
                  _context3.next = 5;
                  return ref.putString(bytes, 'data_url', { cacheControl: 'only-if-cached' });

                case 5:
                  response = _context3.sent;
                  return _context3.abrupt('return', { ref: response, name: image.name, pathRef: ref });

                case 7:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this4);
        }));

        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }()).then(function () {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4(snapshotObj) {
          var downloadURL;
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return snapshotObj.pathRef.getDownloadURL();

                case 2:
                  downloadURL = _context4.sent;
                  return _context4.abrupt('return', { ref: downloadURL, name: snapshotObj.name });

                case 4:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this4);
        }));

        return function (_x3) {
          return _ref5.apply(this, arguments);
        };
      }());
    },
    updateLocalJob: function updateLocalJob(job, key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('outbox', 'readwrite');
        var outboxStore = tx.objectStore('outbox');

        outboxStore.put(job, key);
        return tx.complete;
      }).then(function () {
        return true;
      }).catch(function () {
        return false;
      });
    },
    deleteImageFromDB: function deleteImageFromDB(key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('imageStore', 'readwrite');
        var imageStore = tx.objectStore('imageStore');
        imageStore.delete(key);
        return true;
      }).catch(function () {
        return false;
      });
    },

    // Upload process attempt 2
    // next (doc, job, element) {
    //   let val = job
    //   let toDelete = []
    //   let promises = []
    //   console.log(val.template)
    //   for (let template in val.template) {
    //     val.template[template].items.map((obj, item) => {
    //       promises.push(new Promise((resolve, reject) => {
    //         if (val.template[template].items[item].image !== '') {
    //           toDelete.push(val.template[template].items[item].image)
    //           dbPromise().then(function (db) {
    //             let tx = db.transaction('imageStore')
    //             let imageStore = tx.objectStore('imageStore')
    //             return (imageStore.get(val.template[template].items[item].image))
    //           })
    //           .then((image) => {
    //             if (image !== undefined) {
    //               // Prepare image for sending
    //               let bytes = image.image
    //               let ref = storage.ref(job.JobNo + '/' + image.name)
    //               // Send image
    //               console.info('Sending image')
    //               ref.putString(bytes, 'data_url', {cacheControl: 'only-if-cached'})
    //               .then((snapshot) => {
    //                 job.template[template].items[item].image = snapshot.downloadURL
    //                 job.template[template].items[item].imageName = image.name
    //                 console.log('uploaded')
    //                 console.log(promises)
    //                 resolve('resolved')
    //                 // Image has been successful so safe to remove from IDB
    //                 // On successful removal change flag and check if anything is still sending
    //               })
    //               .catch((error) => {
    //                 console.log('rejected')
    //                 console.log(promises)
    //                 console.log(error)
    //                 reject('rejected')
    //               })
    //             }
    //           })
    //         } else {
    //           resolve('no image')
    //         }
    //       }))
    //     })
    //   }
    //   Promise.all(promises)
    //   .then(async value => {
    //     console.log(value)
    //     if (value.indexOf('rejected') > -1) {
    //       console.log('Image upload failed')
    //       this.snackbarText = 'Image upload failed. Please try again'
    //       this.snackbar = true
    //       return
    //     }
    //     const clean = (object) => {
    //       Object
    //         .entries(object)
    //         .forEach(([k, v]) => {
    //           if (v && typeof v === 'object') {
    //             clean(v)
    //           }
    //           if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined) {
    //             if (Array.isArray(object)) {
    //               object.splice(k, 1)
    //             } else {
    //               delete object[k]
    //             }
    //           }
    //         })
    //       return object
    //     }
    //     let template = await clean(job.template || [])
    //     console.log(job)
    //     const obj = {
    //       Date: job.Date,
    //       JobNo: job.JobNo,
    //       Customer: job.Customer,
    //       imei: job.imei,
    //       template: template,
    //       unscheduled: job.unscheduled,
    //       Vehicle: job.vehicle,
    //       vehicle: job.reg ? job.reg : '',
    //       CompletedDate: job.CompletedDate,
    //       startTime: job.startTime || null,
    //       endTime: job.endTime || null
    //     }
    //     console.log(obj)
    //     fireStore.collection('Jobs/').doc(doc).collection('CompletedJobs').doc()
    //     .set(obj)
    //     .then(() => {
    //       fireStore.collection('Jobs/').doc(doc).update({Status: 2, CompletedDate: job.CompletedDate})
    //       // Data has been successful so safe to remove from IDB
    //       dbPromise().then(function (db) {
    //         let tx = db.transaction('outbox', 'readwrite')
    //         let outboxStore = tx.objectStore('outbox')
    //         outboxStore.delete(parseInt(element))
    //       })
    //       .then(() => {
    //         this.snackbar = true
    //         this.snackbarText = 'Upload Successful'
    //         this.getImages()
    //         for (let deleteIndex in toDelete) {
    //           dbPromise().then(function (db) {
    //             let tx = db.transaction('imageStore', 'readwrite')
    //             let imageStore = tx.objectStore('imageStore')
    //             imageStore.delete(toDelete[deleteIndex])
    //           })
    //         }
    //         this.uploadFile()
    //         this.snackbar = true
    //         this.snackbarText = 'Finished Sending'
    //         this.sending = false
    //       })
    //       .catch(error => {
    //         console.log(error)
    //         this.snackbarText = 'Error updating status'
    //         this.snackbar = true
    //         this.sending = false
    //       })
    //     })
    //     .catch(error => {
    //       console.log(error)
    //       this.snackbarText = 'Error setting completed job'
    //       this.snackbar = true
    //       this.sending = false
    //     })
    //   })
    //   .catch(reason => {
    //     console.log('promise failed')
    //     console.log(reason)
    //     this.snackbarText = 'Error uploading job'
    //     this.snackbar = true
    //     this.sending = false
    //   })
    // },
    zeroFill: function zeroFill(number, width) {
      width -= number.toString().length;
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
      }
      return number;
    }
  }
});

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['initialEmail'],
  data: function data() {
    return {
      email: '',
      password: '',
      ready: true,
      loading: false,
      error: null,
      linkSuccess: false
    };
  },
  created: function created() {
    this.email = this.initialEmail;
  },

  methods: {
    requestPassworReset: function requestPassworReset() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].sendPasswordResetEmail(this.email).then(function () {
        _this.loading = false;
        _this.linkSuccess = true;
      }).catch(function (error) {
        _this.loading = false;
        _this.error = error;
      });
    },
    onDismissed: function onDismissed() {
      this.error = null;
    }
  }
});

/***/ }),

/***/ 373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      ready: false
    };
  },
  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.ready = true;
    }, 1000);
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: {
      handler: function handler(value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/');
        }
      },

      immediate: true
    }
  },
  methods: {
    onSignin: function onSignin() {
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  }
});

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 627:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 630:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 206,
	"./af.js": 206,
	"./ar": 213,
	"./ar-dz": 207,
	"./ar-dz.js": 207,
	"./ar-kw": 208,
	"./ar-kw.js": 208,
	"./ar-ly": 209,
	"./ar-ly.js": 209,
	"./ar-ma": 210,
	"./ar-ma.js": 210,
	"./ar-sa": 211,
	"./ar-sa.js": 211,
	"./ar-tn": 212,
	"./ar-tn.js": 212,
	"./ar.js": 213,
	"./az": 214,
	"./az.js": 214,
	"./be": 215,
	"./be.js": 215,
	"./bg": 216,
	"./bg.js": 216,
	"./bm": 217,
	"./bm.js": 217,
	"./bn": 219,
	"./bn-bd": 218,
	"./bn-bd.js": 218,
	"./bn.js": 219,
	"./bo": 220,
	"./bo.js": 220,
	"./br": 221,
	"./br.js": 221,
	"./bs": 222,
	"./bs.js": 222,
	"./ca": 223,
	"./ca.js": 223,
	"./cs": 224,
	"./cs.js": 224,
	"./cv": 225,
	"./cv.js": 225,
	"./cy": 226,
	"./cy.js": 226,
	"./da": 227,
	"./da.js": 227,
	"./de": 230,
	"./de-at": 228,
	"./de-at.js": 228,
	"./de-ch": 229,
	"./de-ch.js": 229,
	"./de.js": 230,
	"./dv": 231,
	"./dv.js": 231,
	"./el": 232,
	"./el.js": 232,
	"./en-au": 233,
	"./en-au.js": 233,
	"./en-ca": 234,
	"./en-ca.js": 234,
	"./en-gb": 235,
	"./en-gb.js": 235,
	"./en-ie": 236,
	"./en-ie.js": 236,
	"./en-il": 237,
	"./en-il.js": 237,
	"./en-in": 238,
	"./en-in.js": 238,
	"./en-nz": 239,
	"./en-nz.js": 239,
	"./en-sg": 240,
	"./en-sg.js": 240,
	"./eo": 241,
	"./eo.js": 241,
	"./es": 245,
	"./es-do": 242,
	"./es-do.js": 242,
	"./es-mx": 243,
	"./es-mx.js": 243,
	"./es-us": 244,
	"./es-us.js": 244,
	"./es.js": 245,
	"./et": 246,
	"./et.js": 246,
	"./eu": 247,
	"./eu.js": 247,
	"./fa": 248,
	"./fa.js": 248,
	"./fi": 249,
	"./fi.js": 249,
	"./fil": 250,
	"./fil.js": 250,
	"./fo": 251,
	"./fo.js": 251,
	"./fr": 254,
	"./fr-ca": 252,
	"./fr-ca.js": 252,
	"./fr-ch": 253,
	"./fr-ch.js": 253,
	"./fr.js": 254,
	"./fy": 255,
	"./fy.js": 255,
	"./ga": 256,
	"./ga.js": 256,
	"./gd": 257,
	"./gd.js": 257,
	"./gl": 258,
	"./gl.js": 258,
	"./gom-deva": 259,
	"./gom-deva.js": 259,
	"./gom-latn": 260,
	"./gom-latn.js": 260,
	"./gu": 261,
	"./gu.js": 261,
	"./he": 262,
	"./he.js": 262,
	"./hi": 263,
	"./hi.js": 263,
	"./hr": 264,
	"./hr.js": 264,
	"./hu": 265,
	"./hu.js": 265,
	"./hy-am": 266,
	"./hy-am.js": 266,
	"./id": 267,
	"./id.js": 267,
	"./is": 268,
	"./is.js": 268,
	"./it": 270,
	"./it-ch": 269,
	"./it-ch.js": 269,
	"./it.js": 270,
	"./ja": 271,
	"./ja.js": 271,
	"./jv": 272,
	"./jv.js": 272,
	"./ka": 273,
	"./ka.js": 273,
	"./kk": 274,
	"./kk.js": 274,
	"./km": 275,
	"./km.js": 275,
	"./kn": 276,
	"./kn.js": 276,
	"./ko": 277,
	"./ko.js": 277,
	"./ku": 278,
	"./ku.js": 278,
	"./ky": 279,
	"./ky.js": 279,
	"./lb": 280,
	"./lb.js": 280,
	"./lo": 281,
	"./lo.js": 281,
	"./lt": 282,
	"./lt.js": 282,
	"./lv": 283,
	"./lv.js": 283,
	"./me": 284,
	"./me.js": 284,
	"./mi": 285,
	"./mi.js": 285,
	"./mk": 286,
	"./mk.js": 286,
	"./ml": 287,
	"./ml.js": 287,
	"./mn": 288,
	"./mn.js": 288,
	"./mr": 289,
	"./mr.js": 289,
	"./ms": 291,
	"./ms-my": 290,
	"./ms-my.js": 290,
	"./ms.js": 291,
	"./mt": 292,
	"./mt.js": 292,
	"./my": 293,
	"./my.js": 293,
	"./nb": 294,
	"./nb.js": 294,
	"./ne": 295,
	"./ne.js": 295,
	"./nl": 297,
	"./nl-be": 296,
	"./nl-be.js": 296,
	"./nl.js": 297,
	"./nn": 298,
	"./nn.js": 298,
	"./oc-lnc": 299,
	"./oc-lnc.js": 299,
	"./pa-in": 300,
	"./pa-in.js": 300,
	"./pl": 301,
	"./pl.js": 301,
	"./pt": 303,
	"./pt-br": 302,
	"./pt-br.js": 302,
	"./pt.js": 303,
	"./ro": 304,
	"./ro.js": 304,
	"./ru": 305,
	"./ru.js": 305,
	"./sd": 306,
	"./sd.js": 306,
	"./se": 307,
	"./se.js": 307,
	"./si": 308,
	"./si.js": 308,
	"./sk": 309,
	"./sk.js": 309,
	"./sl": 310,
	"./sl.js": 310,
	"./sq": 311,
	"./sq.js": 311,
	"./sr": 313,
	"./sr-cyrl": 312,
	"./sr-cyrl.js": 312,
	"./sr.js": 313,
	"./ss": 314,
	"./ss.js": 314,
	"./sv": 315,
	"./sv.js": 315,
	"./sw": 316,
	"./sw.js": 316,
	"./ta": 317,
	"./ta.js": 317,
	"./te": 318,
	"./te.js": 318,
	"./tet": 319,
	"./tet.js": 319,
	"./tg": 320,
	"./tg.js": 320,
	"./th": 321,
	"./th.js": 321,
	"./tk": 322,
	"./tk.js": 322,
	"./tl-ph": 323,
	"./tl-ph.js": 323,
	"./tlh": 324,
	"./tlh.js": 324,
	"./tr": 325,
	"./tr.js": 325,
	"./tzl": 326,
	"./tzl.js": 326,
	"./tzm": 328,
	"./tzm-latn": 327,
	"./tzm-latn.js": 327,
	"./tzm.js": 328,
	"./ug-cn": 329,
	"./ug-cn.js": 329,
	"./uk": 330,
	"./uk.js": 330,
	"./ur": 331,
	"./ur.js": 331,
	"./uz": 333,
	"./uz-latn": 332,
	"./uz-latn.js": 332,
	"./uz.js": 333,
	"./vi": 334,
	"./vi.js": 334,
	"./x-pseudo": 335,
	"./x-pseudo.js": 335,
	"./yo": 336,
	"./yo.js": 336,
	"./zh-cn": 337,
	"./zh-cn.js": 337,
	"./zh-hk": 338,
	"./zh-hk.js": 338,
	"./zh-mo": 339,
	"./zh-mo.js": 339,
	"./zh-tw": 340,
	"./zh-tw.js": 340
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 641;

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cubo-icon.0091694.png";

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(629)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(668),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(669),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(674),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(628)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(665),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(675),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(678),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(677),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(670),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(679),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(671),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(673),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(667),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(676),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(672),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(666),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(663),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 663:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.ready) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h2', [_vm._v("This app is no longer in use, please contact fleetsupport@motia.com for details of how to access the new Nexus app")])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "ID type",
      "return-object": "",
      "items": _vm.IDSelections,
      "item-text": "name",
      "dense": ""
    },
    model: {
      value: (_vm.IDType),
      callback: function($$v) {
        _vm.IDType = $$v
      },
      expression: "IDType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.IDType.name,
      "dense": ""
    },
    model: {
      value: (_vm.ID),
      callback: function($$v) {
        _vm.ID = $$v
      },
      expression: "ID"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.gettingResults,
      "disabled": _vm.ID.length < 5
    },
    on: {
      "click": _vm.testDevice
    }
  }, [_vm._v("\n        TEST\n      ")])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.error.length > 0,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), (_vm.results.LastUpdate) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_vm._v("Check connected in the last.")]), _vm._v(" "), _c('v-select', {
    ref: "connectedSince",
    staticClass: "mb-0 pb-0",
    attrs: {
      "label": "Custom",
      "items": _vm.connectedSinceItems,
      "hint": _vm.selectionHint,
      "persistent-hint": "",
      "solo": "",
      "prepend-icon": "mdi-calendar"
    },
    on: {
      "click:prepend": function($event) {
        _vm.dateModal = true
      },
      "change": function($event) {
        _vm.selectionHint = ''
      }
    },
    model: {
      value: (_vm.connectedSince),
      callback: function($$v) {
        _vm.connectedSince = $$v
      },
      expression: "connectedSince"
    }
  }), _vm._v(" "), _c('v-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.dateModal),
      callback: function($$v) {
        _vm.dateModal = $$v
      },
      expression: "dateModal"
    }
  }, [_c('v-card', [_c('v-date-picker', {
    staticStyle: {
      "box-shadow": "none"
    },
    attrs: {
      "scrollable": "",
      "no-title": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mx-5",
    attrs: {
      "label": "Time",
      "type": "time",
      "mask": "time",
      "outline": ""
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dateModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": _vm.setCustomDate
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('h3', {
    staticClass: "subheading grey--text"
  }, [_vm._v("Vehicle Section")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.LastUpdate) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.LastUpdate) ? 'check' : 'close')
    }
  }), _vm._v(_vm._s(_vm._f("formatDate")(_vm.results.LastUpdate)))], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Reg")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.Registration))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Friendly Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.FriendlyName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Vehicle Group")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.VehicleGroup))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Address")]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.results.Address)
    }
  })]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Vehicle State")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.VehicleState))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("GPS Fix")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.results.GPSFix > 5 ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.results.GPSFix > 5 ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Ignition On")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.IgnitionOn) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.IgnitionOn) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Ignition Off")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.IgnitionOff) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.IgnitionOff) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("IMEI")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.IMEI))])])])]), _vm._v(" "), _c('h3', {
    staticClass: "subheading grey--text"
  }, [_vm._v("CAN Section")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v("SQ EON")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.SQEon) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.SQEon) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("SQ EOFF")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.SQEoff) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.SQEoff) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("SQ D8 Card Number")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.SQTacho))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("SQ 1 Minute")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.SQ30sNIBC) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.SQ30sNIBC) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Odometer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.Odometer))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Fuel")]), _vm._v(" "), _c('td', [(_vm.results.FuelLevel) ? _c('span', [_vm._v(_vm._s(_vm.results.FuelLevel))]) : _c('v-icon', {
    attrs: {
      "large": "",
      "color": "error"
    },
    domProps: {
      "innerHTML": _vm._s('close')
    }
  })], 1)])])]), _vm._v(" "), _c('h3', {
    staticClass: "subheading grey--text"
  }, [_vm._v("Tacho Section")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v("Driver Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.TachoSysDriverName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("DDS Message Updated")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.TachoSysMessageUpdated) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.TachoSysMessageUpdated) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("TachoSys Card Number")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.TachoSysCardNumber))])])])]), _vm._v(" "), _c('h3', {
    staticClass: "subheading grey--text"
  }, [_vm._v("DVR Section")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v("DVR ID")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.DVRID))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ACC Ignition On")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.ACCIgnitionOnDateTime) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.ACCIgnitionOnDateTime) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Device Online")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.DeviceOnlineDateTime) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.DeviceOnlineDateTime) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("GSM Dial Up OK")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.GSMDialUpOKDateTime) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.GSMDialUpOKDateTime) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HDD Write OK")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.HDDWriteOKDateTime) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.HDDWriteOKDateTime) ? 'check' : 'close')
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.notesDialog = true
      }
    }
  }, [_vm._v("Add additional information")])], 1), _vm._v(" "), (_vm.results.ICCID) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Select Test Message",
      "items": _vm.messageTemplates
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.message.length < 1,
      "loading": _vm.sendingMessage
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v("Send Message")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.notesDialog),
      callback: function($$v) {
        _vm.notesDialog = $$v
      },
      expression: "notesDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('v-card-title', [_vm._v("Use this to record any notes/images against this test.")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Notes"
    },
    model: {
      value: (_vm.extraNotes),
      callback: function($$v) {
        _vm.extraNotes = $$v
      },
      expression: "extraNotes"
    }
  }), _vm._v(" "), _c('v-list', _vm._l((_vm.fileList), function(file, i) {
    return _c('v-list-tile', {
      key: i
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.fileList.splice(i, 1)
        }
      }
    }, [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(file.name))])], 1)], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$refs.fileInput.click()
      }
    }
  }, [_vm._v("Add File(s)")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "hidden": "",
      "multiple": "",
      "type": "file"
    },
    on: {
      "change": _vm.addFiles
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.notesDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary",
      "loading": _vm.savingNotes
    },
    on: {
      "click": _vm.saveExtraDetails
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "success",
      "timeout": 2000
    },
    model: {
      value: (_vm.notesSaved),
      callback: function($$v) {
        _vm.notesSaved = $$v
      },
      expression: "notesSaved"
    }
  }, [_vm._v("\n    Details Saved\n    "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.notesSaved = false
      }
    }
  }, [_vm._v("\n      Close\n    ")])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "success",
      "timeout": 2000
    },
    model: {
      value: (_vm.messageSent),
      callback: function($$v) {
        _vm.messageSent = $$v
      },
      expression: "messageSent"
    }
  }, [_vm._v("\n    Message Sent\n    "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n      Close\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": "",
      "offset-lg3": ""
    }
  }, [_c('v-expansion-panel', {
    staticClass: "mb-2",
    attrs: {
      "popout": "",
      "dark": ""
    }
  }, [_c('v-expansion-panel-content', {
    staticClass: "blue-grey",
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', [_vm._v("Job Details")])]), _vm._v(" "), _c('v-card', [_c('v-list', {
    staticClass: "blue-grey"
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Customer: " + _vm._s(_vm.customerName))])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Vehicle: " + _vm._s(_vm.currentJob.vehicle ? _vm.vehicleRegFromID(_vm.currentJob.vehicle) : _vm.currentJob.reg))])], 1)], 1), _vm._v(" "), (_vm.currentJob.requirements) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Requirements: " + _vm._s(_vm.currentJob.requirements))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.network) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Network: " + _vm._s(_vm.currentJob.network))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.APN) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("APN: " + _vm._s(_vm.currentJob.APN))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.newReg) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("New Reg: " + _vm._s(_vm.currentJob.newReg))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.newMake) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("New Make: " + _vm._s(_vm.currentJob.newMake))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.newModel) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("New Model: " + _vm._s(_vm.currentJob.newModel))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.leaveKit) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Where to leave kit: " + _vm._s(_vm.currentJob.leaveKit))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.getKit) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Where to get kit: " + _vm._s(_vm.currentJob.getKit))])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "popout": "",
      "dark": ""
    }
  }, _vm._l((_vm.templates), function(item, i) {
    return _c('v-expansion-panel-content', {
      key: i,
      class: _vm.checkListComplete(i),
      attrs: {
        "lazy": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('strong', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('v-card', [_c('v-list', {
      attrs: {
        "three-line": ""
      }
    }, [_vm._l((_vm.templates[i].items), function(subitem, index) {
      return _c('v-list-group', {
        key: index,
        attrs: {
          "lazy": "",
          "avatar": "",
          "value": true
        }
      }, [(subitem.text !== undefined && subitem.text.indexOf('c.isni.co') !== -1 && !subitem.test) ? _c('v-list-tile', [_c('a', {
        staticClass: "cyan--text",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.gotoIsniTestPage.apply(null, arguments)
          }
        }
      }, [_vm._v(" Visit Test Site"), _c('v-icon', [_vm._v("open_in_new")])], 1)]) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', {
        attrs: {
          "icon": "",
          "color": (subitem.image && subitem.image.length > 0) || (subitem.note && subitem.note.length > 0) > 0 ? 'green' : 'grey'
        },
        domProps: {
          "innerHTML": _vm._s(_vm.listIcon(subitem))
        }
      })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
        staticClass: "mb-2"
      }, [_vm._v(_vm._s(subitem.title))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(subitem.text))])], 1), _vm._v(" "), (!subitem.optional === true) ? _c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "color": "grey lighten-1"
        }
      }, [_vm._v("visibility")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile', [(subitem.photo && !subitem.test) ? [(subitem.image) ? _c('img', {
        attrs: {
          "src": _vm.imageObj[subitem.image],
          "height": "80"
        },
        on: {
          "click": function($event) {
            return _vm.openFullImage(_vm.imageObj[subitem.image], i, index)
          }
        }
      }) : _c('v-btn', {
        attrs: {
          "loading": _vm.imageProcessing,
          "color": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.triggerPick(i, index, 'photo')
          }
        }
      }, [_c('v-icon', [_vm._v("add_a_photo")]), _vm._v(_vm._s(subitem.image ? ' Change Photo' : ' Add Photo'))], 1)] : _vm._e(), _vm._v(" "), (!subitem.test) ? [(subitem.note) ? _c('p', {
        staticClass: "pa-1 mb-0 ml-1 white black--text",
        staticStyle: {
          "overflow": "hidden",
          "display": "-webkit-box",
          "box-orient": "vertical",
          "line-clamp": "3",
          "height": "80px",
          "width": "100%"
        },
        on: {
          "click": function($event) {
            return _vm.triggerPick(i, index, 'note')
          }
        }
      }, [_vm._v(_vm._s(subitem.note))]) : _c('v-btn', {
        attrs: {
          "color": "primary",
          "disabled": subitem.photo && subitem.image.length < 1
        },
        on: {
          "click": function($event) {
            return _vm.triggerPick(i, index, 'note')
          }
        }
      }, [_c('v-icon', [_vm._v("note_add")]), _vm._v(_vm._s(subitem.note ? ' Change Note' : ' Add Note'))], 1)] : _vm._e(), _vm._v(" "), (subitem.test) ? _c('v-btn', {
        attrs: {
          "color": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.gotoTestPage(i, index)
          }
        }
      }, [_c('v-icon', [_vm._v("mdi-cloud-check")]), _vm._v(" Run Test")], 1) : _vm._e()], 2)], 1)
    }), _vm._v(" "), (item.name === 'Lisle RDL') ? _c('v-list-group', {
      attrs: {
        "lazy": "",
        "avatar": "",
        "value": true
      }
    }, [_c('v-list-tile', [_c('v-btn', {
      attrs: {
        "color": "primary",
        "block": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.rdlTest()
        }
      }
    }, [_vm._v("Test RDL")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.name === 'Digi-DL') ? _c('v-list-group', {
      attrs: {
        "lazy": "",
        "avatar": "",
        "value": true
      }
    }, [_c('v-list-tile', [_c('v-btn', {
      attrs: {
        "color": "primary",
        "block": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.dlTest()
        }
      }
    }, [_vm._v("Test DL")])], 1)], 1) : _vm._e()], 2)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-textarea', {
    staticClass: "mx-2",
    attrs: {
      "label": "General Notes"
    },
    on: {
      "change": _vm.saveJob
    },
    model: {
      value: (_vm.currentJob.notes),
      callback: function($$v) {
        _vm.$set(_vm.currentJob, "notes", $$v)
      },
      expression: "currentJob.notes"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-2",
    attrs: {
      "label": "Is this job chargeable?"
    },
    on: {
      "change": _vm.saveJob
    },
    model: {
      value: (_vm.currentJob.chargeable),
      callback: function($$v) {
        _vm.$set(_vm.currentJob, "chargeable", $$v)
      },
      expression: "currentJob.chargeable"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.saveForLater
    }
  }, [_vm._v("Save for Later")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.readyToSend,
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.completeJob
    }
  }, [_vm._v("Save and Send")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.downloadJob
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("archive")]), _vm._v(" Download Zip File")], 1), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "imagePicker",
      "type": "file",
      "accept": "image/jpeg"
    },
    on: {
      "change": _vm.saveImages
    }
  }), _vm._v(" "), _c('canvas', {
    attrs: {
      "hidden": "",
      "id": "imageCanvas"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    model: {
      value: (_vm.enterNote),
      callback: function($$v) {
        _vm.enterNote = $$v
      },
      expression: "enterNote"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.enterNote = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Note")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveNote.apply(null, arguments)
      }
    }
  }, [_vm._v("Save Note")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Add notes here"
    },
    model: {
      value: (_vm.currentNote),
      callback: function($$v) {
        _vm.currentNote = $$v
      },
      expression: "currentNote"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    model: {
      value: (_vm.fullImage),
      callback: function($$v) {
        _vm.fullImage = $$v
      },
      expression: "fullImage"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.fullImage = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.changeImage
    }
  }, [_vm._v("Change Image")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.fullImageSrc
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.testingDialog),
      callback: function($$v) {
        _vm.testingDialog = $$v
      },
      expression: "testingDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.testingDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Testing")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.testingDialog = false
      }
    }
  }, [_vm._v("Save Test")])], 1)], 1), _vm._v(" "), _c('testing', {
    attrs: {
      "testType": _vm.testType,
      "testID": _vm.testID
    },
    on: {
      "testId": _vm.saveTest
    }
  })], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.rdlTestDialog),
      callback: function($$v) {
        _vm.rdlTestDialog = $$v
      },
      expression: "rdlTestDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("RDL Testing")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.rdlTestDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100vh"
    },
    attrs: {
      "id": "rdlFrame",
      "src": "https://m.digidown.net/rdl_status/"
    }
  })], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.dlTestDialog),
      callback: function($$v) {
        _vm.dlTestDialog = $$v
      },
      expression: "dlTestDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("DL Testing")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.dlTestDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100vh"
    },
    attrs: {
      "id": "dlFrame",
      "src": "https://cwelite.aquariusit.com/dl-status/"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.ready) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [(_vm.error) ? _c('v-layout', [_c('app-alert', {
    attrs: {
      "text": _vm.error.message
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "success",
      "dismissible": "",
      "value": _vm.linkSuccess
    }
  }, [_vm._v("\n                You will receive an email with a link to reset your password.\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.requestPassworReset.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.linkSuccess,
      "block": "",
      "type": "submit",
      "color": "primary",
      "loading": _vm.loading
    }
  }, [_vm._v("Request Password Link")])], 1)], 1)], 1)])], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 667:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [(_vm.gettingData) ? _c('v-flex', [_c('v-card', {
    staticClass: "pa-2 ma-1 text-xs-center",
    attrs: {
      "to": "/JobList"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 60,
      "width": 8,
      "color": "primary",
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Fetching Recent Job Status")])], 1)], 1) : [_c('v-flex', [_c('v-card', {
    staticClass: "pa-2 ma-1 text-xs-center",
    attrs: {
      "to": "/JobList"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 60,
      "width": 8,
      "rotate": 360,
      "value": _vm.jobsNotStarted / _vm.data.length * 100,
      "color": "primary"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.jobsNotStarted) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("Jobs Not Started")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', {
    staticClass: "pa-2 ma-1 text-xs-center",
    attrs: {
      "to": "/JobList"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 60,
      "width": 8,
      "rotate": 360,
      "value": _vm.jobsStarted / _vm.data.length * 100,
      "color": "info"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.jobsStarted) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("Jobs Started")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', {
    staticClass: "pa-2 ma-1 text-xs-center",
    attrs: {
      "to": "/Outbox"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 60,
      "width": 8,
      "rotate": 360,
      "value": _vm.jobsNotUploaded / _vm.data.length * 100,
      "color": "error"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.jobsNotUploaded) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("Jobs Not Uploaded")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', {
    staticClass: "pa-2 ma-1 text-xs-center",
    on: {
      "click": function($event) {
        _vm.completedDialog = true
      }
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 60,
      "width": 8,
      "rotate": 360,
      "value": _vm.jobsCompleted / _vm.data.length * 100,
      "color": "success"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.jobsCompleted) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("Jobs Completed Last 14 Days")])], 1)], 1)], _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.completedDialog),
      callback: function($$v) {
        _vm.completedDialog = $$v
      },
      expression: "completedDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("Completed Jobs Last 14 Days")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.completedDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _vm._l((_vm.completedJobs), function(job, i) {
    return _c('v-list', {
      key: i,
      staticClass: "green mb-2",
      attrs: {
        "dark": "",
        "three-line": ""
      }
    }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(job.Vehicle ? _vm.vehicleRegFromID(job.Vehicle) : job.vehReg))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Job ID: " + _vm._s(job.JobNo))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Completed: " + _vm._s(_vm._f("formatDate")(job.CompletedDate)))])], 1)], 1)], 1)
  })], 2)], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "app": "",
      "right": "",
      "temporary": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/",
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Home")])], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/settings"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Settings")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-5 mb-2"
  }), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile', {
    attrs: {
      "router": ""
    },
    on: {
      "click": _vm.onLogout
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Log Out")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "fixed": "",
      "app": "",
      "color": "secondary",
      "dark": ""
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goBack.apply(null, arguments)
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(645),
      "width": "50"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-toolbar-side-icon', {
    attrs: {
      "right": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.templates.length > 20 && _vm.oldTemplates.length > 10) ? _c('v-content', [_c('router-view')], 1) : _c('v-content', [_c('v-progress-linear', {
    attrs: {
      "indeterminate": _vm.templates < 1,
      "query": true
    },
    model: {
      value: (_vm.templates.length),
      callback: function($$v) {
        _vm.$set(_vm.templates, "length", $$v)
      },
      expression: "templates.length"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "text-xs-center display-1"
  }, [_vm._v(_vm._s('Downloading Job Templates'))]), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "indeterminate": _vm.templates < 1,
      "query": true
    },
    model: {
      value: (_vm.templates.length),
      callback: function($$v) {
        _vm.$set(_vm.templates, "length", $$v)
      },
      expression: "templates.length"
    }
  })], 1), _vm._v(" "), _c('update-dialog', {
    attrs: {
      "dialog": _vm.newVersion
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 669:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-card', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "flat": ""
    }
  }, [(!_vm.messageSent) ? _c('v-container', {
    staticClass: "text-xs-center"
  }, [_c('v-select', {
    attrs: {
      "label": "Message Type",
      "items": _vm.types,
      "item-value": "type",
      "item-text": "name"
    },
    model: {
      value: (_vm.messageType),
      callback: function($$v) {
        _vm.messageType = $$v
      },
      expression: "messageType"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.lookupDialog = true
      }
    }
  }, [_vm._v("\n            Lookup ICCID\n      ")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Bulk Paste",
      "color": "primary"
    },
    model: {
      value: (_vm.bulk),
      callback: function($$v) {
        _vm.bulk = $$v
      },
      expression: "bulk"
    }
  }), _vm._v(" "), (_vm.bulk) ? _c('v-textarea', {
    attrs: {
      "label": "Bulk Paste ICCID's Here"
    },
    on: {
      "keydown": function($event) {
        $event.preventDefault();
      },
      "input": _vm.updateICCID
    },
    model: {
      value: (_vm.inputICCID),
      callback: function($$v) {
        _vm.inputICCID = $$v
      },
      expression: "inputICCID"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.bulk) ? _c('v-combobox', {
    attrs: {
      "chips": "",
      "deletable-chips": "",
      "label": "Input ICCID and press enter",
      "type": "number",
      "multiple": "",
      "outline": ""
    },
    model: {
      value: (_vm.ICCIDarray),
      callback: function($$v) {
        _vm.ICCIDarray = $$v
      },
      expression: "ICCIDarray"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Message Template",
      "items": _vm.messageTemplates,
      "multiple": "",
      "chips": "",
      "deletable-chips": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _vm._l((_vm.message), function(m, i) {
    return _c('v-text-field', {
      key: i,
      attrs: {
        "label": 'Message To Send ' + (i + 1),
        "append-icon": _vm.$vuetify.icons.clear
      },
      on: {
        "click:append": function($event) {
          return _vm.message.splice(i, 1)
        }
      },
      model: {
        value: (_vm.message[i]),
        callback: function($$v) {
          _vm.$set(_vm.message, i, $$v)
        },
        expression: "message[i]"
      }
    })
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.message || _vm.ICCIDarray.length < 1,
      "loading": _vm.sending
    },
    on: {
      "click": _vm.sendMessages
    }
  }, [_vm._v("Send Messages")])], 2) : _vm._e()], 1), _vm._v(" "), (_vm.messageSent) ? _c('v-container', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Return")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredMessageStates,
      "expand": _vm.expandResults,
      "item-key": "id",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.ICCID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.message))]), _vm._v(" "), _c('td', [(props.item.state === 0) ? _c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "primary"
          }
        }) : _c('v-icon', {
          attrs: {
            "color": props.item.state === -1 ? 'error' : 'success'
          }
        }, [_vm._v("\n              " + _vm._s(props.item.state === -1 ? 'mdi-alert-circle' : 'mdi-check-circle') + "\n            ")])], 1)])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-card', {
          attrs: {
            "flat": ""
          }
        }, [(props.item.packet) ? _c('v-card-text', [_vm._v("Request"), _c('pre', [_vm._v(_vm._s(props.item.packet))])]) : _vm._e(), _vm._v(" "), (props.item.response) ? _c('v-card-text', [_vm._v("Response"), _c('pre', [_vm._v(_vm._s(props.item.response))])]) : _vm._e()], 1)]
      }
    }], null, false, 4244855109)
  })], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.lookupDialog),
      callback: function($$v) {
        _vm.lookupDialog = $$v
      },
      expression: "lookupDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Lookup ICCID from ESN or IMEI")]), _vm._v(" "), _c('v-card-text', [_vm._v("Choose the source and type you want to use as a lookup.")]), _vm._v(" "), _c('v-card-text', [_c('v-select', {
    attrs: {
      "items": ['ESN', 'IMEI']
    },
    model: {
      value: (_vm.lookupType),
      callback: function($$v) {
        _vm.lookupType = $$v
      },
      expression: "lookupType"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": ['Nexus', 'Calamp-CTC']
    },
    model: {
      value: (_vm.lookupSource),
      callback: function($$v) {
        _vm.lookupSource = $$v
      },
      expression: "lookupSource"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": ("Enter " + _vm.lookupType)
    },
    model: {
      value: (_vm.lookupNumber),
      callback: function($$v) {
        _vm.lookupNumber = $$v
      },
      expression: "lookupNumber"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.lookupNumber,
      "loading": _vm.lookingUp,
      "block": "",
      "color": "success"
    },
    on: {
      "click": _vm.lookupICCID
    }
  }, [_vm._v("Lookup")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v("OR")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.lookupDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": ""
    },
    model: {
      value: (_vm.lookupNoResults),
      callback: function($$v) {
        _vm.lookupNoResults = $$v
      },
      expression: "lookupNoResults"
    }
  }, [_vm._v("\n      No Results found for that number.\n      "), _c('v-btn', {
    attrs: {
      "color": "pink",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.lookupNoResults = false
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-snackbar', {
    attrs: {
      "color": "accent"
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.snackbarIcon))]), _vm._v(_vm._s(_vm.snackbarText))], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [(_vm.jobs.length === 0) ? _c('p', [_vm._v("Outbox is empty")]) : _vm._l((_vm.jobs), function(job) {
    return _c('v-card', {
      key: job.number,
      staticClass: "my-2"
    }, [_c('v-container', {
      attrs: {
        "fluid": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('h3', [_vm._v(_vm._s(job.JobNo))])]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('h5', {
      staticClass: "subheading"
    }, [_vm._v(_vm._s(_vm._f("customerNameFromId")(job.Customer, _vm.customers)) + " " + _vm._s(_vm.imageCount(job).sent) + "/" + _vm._s(_vm.imageCount(job).count) + " images sent")])]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "align-center": "",
        "justify-space-around": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.downloadJob(job.number)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("file_download")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.uploadJob(job.number)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("file_upload")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteJob(job.number)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "error"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.logDialog),
      callback: function($$v) {
        _vm.logDialog = $$v
      },
      expression: "logDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.logDialogTitle))]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.copyLog
    }
  }, [_vm._v("Copy")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.sendDebugLog
    }
  }, [_vm._v("Send Log")])], 1), _vm._v(" "), _c('v-textarea', {
    ref: "logTextField",
    staticClass: "pt-0",
    attrs: {
      "rows": "10",
      "label": "Log",
      "autofocus": ""
    },
    model: {
      value: (_vm.logDialogLog),
      callback: function($$v) {
        _vm.logDialogLog = $$v
      },
      expression: "logDialogLog"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.logDialogInfo))])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "grey darken-2",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.logDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 671:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-alert', {
    attrs: {
      "error": "",
      "dismissible": "",
      "value": true
    },
    on: {
      "input": _vm.onClose
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.images.length < 1 || _vm.sending,
      "color": _vm.outboxColor,
      "large": "",
      "flat": ""
    },
    on: {
      "click": _vm.uploadFile
    }
  }, [_c('v-badge', {
    attrs: {
      "left": "",
      "overlap": "",
      "color": "orange"
    },
    model: {
      value: (_vm.showOutboxCount),
      callback: function($$v) {
        _vm.showOutboxCount = $$v
      },
      expression: "showOutboxCount"
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.imageCount))]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("file_upload")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "text-xs-center"
  }, [_vm._v("Empty Outbox")])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "display-1 grey--text text--darken-2 text-xs-center"
  }, [_vm._v("Disclaimer")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', [_vm._v("Creating a job requires permission from Cubo. By accepting this disclaimer, you understand that creating a job without permission could result in you not being paid for the work carried out.")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-btn', {
    staticClass: "success",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.acceptDisclaimer
    }
  }, [_vm._v("Accept")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "offset-xs1": "",
      "xs3": ""
    }
  }, [_c('v-btn', {
    staticClass: "error",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.declineDisclaimer
    }
  }, [_vm._v("Decline")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.currentAlert),
      callback: function($$v) {
        _vm.currentAlert = $$v
      },
      expression: "currentAlert"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Job already in progress")]), _vm._v(" "), _c('v-card-text', [_vm._v("There is already a job in progress, by creating a new job you will lose any progress. Are you sure\n        you want discard the current job?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.discardCurrentJob.apply(null, arguments)
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "to": "/CurrentJob"
    }
  }, [_vm._v("Continue")])], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-flex', {
    attrs: {
      "xs-12": ""
    }
  }, [_c('v-card', [_c('v-container', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Customer",
      "items": _vm.customers,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "no-data-text": "No Results - Please type at least 3 characters",
      "rules": _vm.customerRules,
      "search-input": _vm.customerFilter,
      "loading": _vm.customerLoading
    },
    on: {
      "update:searchInput": function($event) {
        _vm.customerFilter = $event
      },
      "update:search-input": function($event) {
        _vm.customerFilter = $event
      }
    },
    model: {
      value: (_vm.currentJob.Customer),
      callback: function($$v) {
        _vm.$set(_vm.currentJob, "Customer", $$v)
      },
      expression: "currentJob.Customer"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Vehicle Registration",
      "items": _vm.vehicles,
      "item-text": "VehicleReg",
      "item-value": "VehicleReg",
      "return-object": false,
      "required": "",
      "rules": _vm.vehicleRules
    },
    model: {
      value: (_vm.currentJob.Vehicle),
      callback: function($$v) {
        _vm.$set(_vm.currentJob, "Vehicle", $$v)
      },
      expression: "currentJob.Vehicle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "IMEI Number",
      "type": "number"
    },
    model: {
      value: (_vm.currentJob.imei),
      callback: function($$v) {
        _vm.$set(_vm.currentJob, "imei", $$v)
      },
      expression: "currentJob.imei"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Checklists required")]), _vm._v(" "), _vm._l((_vm.templates), function(item, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "label": item.name,
        "disabled": !item.optional
      },
      model: {
        value: (item.required),
        callback: function($$v) {
          _vm.$set(item, "required", $$v)
        },
        expression: "item.required"
      }
    })
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.valid,
      "block": "",
      "color": "success",
      "loading": _vm.creating
    },
    on: {
      "click": _vm.createJob
    }
  }, [_vm._v("\n              Create Job\n            ")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.duplicateDialog),
      callback: function($$v) {
        _vm.duplicateDialog = $$v
      },
      expression: "duplicateDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Job already in system")]), _vm._v(" "), _c('v-card-text', [_vm._v("A job for this vehicle is already present in the system. Do you want use the orriginal or\n          continue to create a new job?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.confirmAndCreate
    }
  }, [_vm._v("Create New")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.createFromOGJob
    }
  }, [_vm._v("Keep Original")])], 1)], 1)], 1), _vm._v(" "), _c('disclaimer-dialog', {
    attrs: {
      "dialog": _vm.disclaimerDialog
    },
    on: {
      "update:dialog": function($event) {
        _vm.disclaimerDialog = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-container', [_c('v-alert', {
    attrs: {
      "color": "error",
      "icon": "cloud_off",
      "value": !_vm.online,
      "transition": "scale-transition"
    }
  }, [_vm._v("\n      No Connection, using saved data.\n    ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "info",
      "value": !_vm.hasCustomers && !_vm.loading,
      "icon": "info_outline"
    }
  }, [_vm._v("\n      You have not been granted access to any customers yet\n    ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center"
  }, [(_vm.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": "primary"
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.jobs), function(job, i) {
    return _c('v-list', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      key: i,
      staticClass: "mb-2 pa-2",
      attrs: {
        "dark": "",
        "two-line": ""
      }
    }, [_c('v-list-tile', {
      attrs: {
        "to": '/JobList/' + job.customer + '/' + job.number
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Customer: " + _vm._s(job.customer))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Number: " + _vm._s(job.number))])], 1)], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("New Version")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        An important update is available and must be installed before you can continue using the app.\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "amber accent-4",
      "block": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.update()
      }
    }
  }, [_vm._v("\n            Update Now\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.notesDialog),
      callback: function($$v) {
        _vm.notesDialog = $$v
      },
      expression: "notesDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Edit Notes")]), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    model: {
      value: (_vm.editNotes),
      callback: function($$v) {
        _vm.editNotes = $$v
      },
      expression: "editNotes"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.notesDialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "loading": _vm.savingNotes
    },
    on: {
      "click": _vm.saveNotes
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.startAlert),
      callback: function($$v) {
        _vm.startAlert = $$v
      },
      expression: "startAlert"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Start Job")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.activeJob.Allocated !== _vm.user.id,
      "color": "warning",
      "icon": "priority_high"
    }
  }, [_vm._v("\n        This job is not assigned to you "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.assigning
    },
    on: {
      "click": _vm.assignJob
    }
  }, [_c('v-icon', [_vm._v("assignment_ind")]), _vm._v("Assign")], 1)], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.activeJob.jobStarted,
      "color": "error",
      "icon": "priority_high"
    }
  }, [_vm._v("\n        This job has been flagged as started!\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you wish to start job "), _c('strong', [_vm._v(_vm._s(_vm.activeJob.JobNo))]), _vm._v(", any uncomplete jobs will be discarded?")]), _vm._v(" "), (_vm.activeJob.Allocated !== _vm.user.id) ? _c('v-card-text', [_vm._v("This job will be automatically assigned to you if you choose to continue.")]) : _vm._e(), _vm._v(" "), _c('v-subheader', [_vm._v("Summary")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "dark": ""
    }
  }, _vm._l((_vm.templateSummary), function(template, i) {
    return _c('v-list-tile', {
      key: i
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(template))])], 1)
  }), 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.startAlert = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.startJob
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.continueAlert),
      callback: function($$v) {
        _vm.continueAlert = $$v
      },
      expression: "continueAlert"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Continue Job")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you wish to continue job "), _c('strong', [_vm._v(_vm._s(_vm.activeJob.JobNo))]), _vm._v(", any uncomplete jobs will be discarded?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.continueAlert = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.continueJob
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-3": ""
    }
  }, [(_vm.user.unassigned) ? _c('v-flex', {
    staticClass: "text-xs-left pr-2",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Filter by Engineer",
      "items": _vm.engineerSelect,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.selectEngineer),
      callback: function($$v) {
        _vm.selectEngineer = $$v
      },
      expression: "selectEngineer"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left pr-2",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Filter by Customer",
      "items": _vm.customers,
      "item-text": "name",
      "item-value": "id",
      "no-data-text": "No Results - Please type at least 3 characters",
      "search-input": _vm.customerFilter,
      "clearable": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.customerFilter = $event
      },
      "update:search-input": function($event) {
        _vm.customerFilter = $event
      }
    },
    model: {
      value: (_vm.selectCustomer),
      callback: function($$v) {
        _vm.selectCustomer = $$v
      },
      expression: "selectCustomer"
    }
  })], 1), _vm._v(" "), (_vm.jobVehicles.length > 0) ? _c('v-flex', {
    staticClass: "text-xs-left px-2",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Filter by Vehicle",
      "items": _vm.jobVehicles,
      "item-text": "reg",
      "item-value": "id",
      "clearable": ""
    },
    model: {
      value: (_vm.selectVehicle),
      callback: function($$v) {
        _vm.selectVehicle = $$v
      },
      expression: "selectVehicle"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Search by Job ID",
      "clearable": ""
    },
    model: {
      value: (_vm.jobFilter),
      callback: function($$v) {
        _vm.jobFilter = $$v
      },
      expression: "jobFilter"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Include Completed",
      "color": "primary"
    },
    model: {
      value: (_vm.includeCompleted),
      callback: function($$v) {
        _vm.includeCompleted = $$v
      },
      expression: "includeCompleted"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [(_vm.listView) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading,
      "round": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.getJobs()
      }
    }
  }, [_vm._v("Load Jobs")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right pl-2",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_vm._v("\n        Layout: \n        "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary",
      "flat": !_vm.listView
    },
    on: {
      "click": function($event) {
        _vm.listView = !_vm.listView
      }
    }
  }, [_c('v-icon', [_vm._v("list")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary",
      "flat": _vm.listView
    },
    on: {
      "click": function($event) {
        _vm.listView = !_vm.listView
      }
    }
  }, [_c('v-icon', [_vm._v("today")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.listView),
      expression: "!listView"
    }],
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.yesterday()
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs10": ""
    }
  }, [_c('v-menu', {
    ref: "date",
    attrs: {
      "return-value": _vm.date,
      "lazy": "",
      "transition": "scale-transition"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    model: {
      value: (_vm.dateMenu),
      callback: function($$v) {
        _vm.dateMenu = $$v
      },
      expression: "dateMenu"
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("today")]), _vm._v("\n          " + _vm._s(_vm.dateFormatted) + "\n        ")], 1), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dateMenu = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.date.save(_vm.date)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.tomorrow()
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": "primary"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "error",
      "icon": "cloud_off",
      "value": !_vm.online,
      "transition": "scale-transition"
    }
  }, [_vm._v("\n      No Connection, using saved data.\n    ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "info",
      "value": !_vm.hasCustomers && !_vm.loading,
      "icon": "info_outline"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.listView ? 'You do not have any jobs' : 'You do not have any jobs on this day') + "\n    ")]), _vm._v(" "), (_vm.hasCustomers && !_vm.loading && _vm.vehicleFilteredJobs.length > 0) ? _vm._l((_vm.vehicleFilteredJobs), function(job, i) {
    return _c('v-list', {
      key: i,
      class: [(job.Status === 2 || _vm.outboxItems.indexOf(job.number) !== -1 ? 'green' : _vm.inProgressKeys[job.number] ? 'orange lighten-1' : ''), 'mb-2 pa-2'],
      attrs: {
        "dark": ""
      }
    }, [_c('v-list-tile', {
      attrs: {
        "three-line": ""
      }
    }, [_c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openEditNoteDialog(job)
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.activateJob(job)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(job.Vehicle ? _vm.vehicleRegFromID(job.Vehicle) : job.vehReg))]), _vm._v(" "), (job.Date) ? _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm._f("formatDate")(job.Date)))]) : _vm._e(), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Job ID: " + _vm._s(job.JobNo))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Project ID: " + _vm._s(job.Project))]), _vm._v("\n            " + _vm._s(job.notes) + "\n          ")], 1), _vm._v(" "), (_vm.isCurrentJob(job)) ? _c('v-icon', [_vm._v("schedule")]) : (_vm.outboxItems.indexOf(job.number) !== -1) ? _c('v-icon', [_vm._v("mdi-sync-off")]) : (_vm.inProgressKeys[job.number]) ? _c('v-icon', [_vm._v("mdi-progress-clock")]) : _vm._e()], 1)], 1)
  }) : _vm._e(), _vm._v(" "), (_vm.hasCustomers && !_vm.loading && _vm.selectCustomer && _vm.vehicleFilteredJobs.length === 0) ? [_c('h3', {
    staticClass: "text-xs-center"
  }, [_vm._v("No jobs found for this customer")])] : _vm._e()], 2), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "multi-line": "",
      "color": "error"
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('h2', [_vm._v("This app is no longer in use, please contact fleetsupport@motia.com for details of how to access the new Nexus app.")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    attrs: {
      "inset": ""
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": item.action
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      class: [item.iconClass]
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.subtitle))])], 1)], 1)
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', {
    staticClass: "grey lighten-1 white--text"
  }, [_vm._v("camera")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Camera Quality")]), _vm._v(" "), _c('v-slider', {
    staticClass: "px-3",
    attrs: {
      "min": "20",
      "thumb-label": "",
      "step": "10",
      "ticks": ""
    },
    model: {
      value: (_vm.cameraQuality),
      callback: function($$v) {
        _vm.cameraQuality = $$v
      },
      expression: "cameraQuality"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    attrs: {
      "inset": ""
    }
  }, [_vm._v("Job Queue")]), _vm._v(" "), _vm._l((_vm.jobQueueArray), function(job) {
    return _c('v-list-tile', {
      key: job
    }, [_c('v-list-tile-avatar'), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n            Job Number : " + _vm._s(_vm.jobQueue[job].JobNo) + "\n          ")])], 1)
  })], 2)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(344);
module.exports = __webpack_require__(343);


/***/ })

},[687]);


// WEBPACK FOOTER //
// static/js/app.3185048a1c5e8567378f.js